export const DE = {
  preparing_zip: "ZIP wird vorbereitet…",
  compressing: "Wird komprimiert…",
  info_icon:"Sobald das Projekt als abgeschlossen markiert wird, können keine neuen Mitglieder mehr beitreten oder hinzugefügt werden, und alle Chats werden deaktiviert. Das Projekt sowie alle Chats und Daten bleiben im deaktivierten Zustand weiterhin zugänglich.",
  mark_is_done:"Möchtest du das Projekt wirklich als abgeschlossen markieren? Sobald das Projekt als abgeschlossen markiert wird, können keine neuen Mitglieder mehr beitreten oder hinzugefügt werden, und alle Chats werden deaktiviert. Das Projekt sowie alle Chats und Daten bleiben im deaktivierten Zustand weiterhin zugänglich.",
  mark_not_done:"Möchtest du das Projekt wirklich wieder öffnen? Sobald das Projekt wieder offen ist, können neuen Mitglieder beitreten oder hinzugefügt werden, und alle Chats werden reaktiviert.",
  mark_as_completed:"Als abgeschlossen markieren",
  room_completed:"Projekt abgeschlossen",
  room_members: "Mitglieder des Projekts",
  deactivated_rooms: "Deaktivierte Projekte",
  deactivated_chats: "Deaktivierte Chats",
  completed_rooms: "Abgeschlossene Projekte",
  request_to_join_a_room: 'Anfrage zum Beitritt beim Projekt',
  wants_to_rejoin_room: 'Username möchte dem Projekt Roomname wieder beitreten.',
  invited_you_to_join_room: 'Username möchte dich zum Projekt Roomname hinzufügen.',
  update_text: "Ein neues Update ist verfügbar. Klicke auf Neustart um das Update zu installieren.",
  restart:"Neustart",
  update_availble: "Update verfügbar",
  Loading:"Läd...",
  logout: "Abmelden",
  company_list: "Firmenliste",
  followers: "Abonnenten",
  followings: "Abonniert",
  article: "Artikel",
  articlen: "Artikeln",
  invite_user_to_confirm_service:
    "Lade Teilnehmer*innen von Kjuup dazu ein deine Leistungen zu bestätigen.",
  companies: "Firmen",
  one_to_one_chat: " Eins zu Eins Chat",
  profile: "Profileinstellungen",
  company: "Firma",
  company_selection: "Firmenauswahl",
  home: "Zuhause",
  contact: "Kontakt",
  company_contact: "Kontakt",
  add: "hinzufügen",
  add_company: "Firma hinzufügen",
  add_project: "Projekt hinzufügen",
  capacities: "Kapazitäten",
  work_area: "Arbeitsbereich",
  of: "von",
  company_services: "Firmenleistungen",
  profile_company_services: "Firmenleistungen",
  deselect_all: "Alle abwählen",
  select_all: "Alle auswählen",
  company_details_service: "Firmenleistungen",
  website: "Webseite",
  website_optional: "Webseite (optional)",
  optional: "optional",
  search_contacts: "Kontakte suchen",
  add_or_join_a_company: "Firma hinzufügen oder beitreten",
  follow: "Abonnieren",
  mutual_contact: "gemeinsamer Kontakt",
  mutual_contacts: "gemeinsame Kontakte",
  following: "Abonniert",
  like: "Gefällt mir",
  company_contacts: "Firmenkontakt",
  profile_company_contacts: "Firmenkontakt",
  leave_the_company: "Die Firma verlassen",
  news: "Mitteilungen",
  earlier: "Früher",
  action: "Aktion",
  another_action: "Eine andere Aktion",
  something_else: "etwas anderes",
  search: "Suche",
  search_rooms: "Projekte suchen",
  search_articles: "Artikel suchen",
  contacts: "Kontakte",
  suggestions: "Vorschläge",
  project_list: "Projektliste",
  search_results: "Suchergebnisse",
  add_or_join_project: "Projekt hinzufügen oder beitreten",
  details: "Details",
  map: "Karte",
  or: "Oder",
  name: "Name*",
  street: "Straße*",
  house_number: "Hausnr.",
  postal_code: "Postleitzahl",
  city: "Stadt*",
  opened_by: "Geöffnet von:",
  project_No: "Projekt-nr: ",
  building_type: "Gebäudetyp*",
  building_types: "Gebäudetyp",
  add_join: "Beitreten/Hinzufügen",
  mandatory_fiels: "*Pflichtfeld",
  invalid_fiels: "Pflichtfeld",
  add_or_join_company: "Firma hinzufügen oder beitreten",
  edit_company_details: "Firmeninformationen bearbeiten",
  name_of_the_company: "Name",
  branch_of_the_building_industry: "Branche der Bauindustrie",
  corporate_form: "Gesellschaftsform",
  position_within_company: "Position in der Firma",
  request_confirmation: "Ausstehende Projekteinladungen",
  company_e_mail: "Firmen E-Mail",
  type_of_filter: "Typ zum Filtern ...",
  setting: "Rahmen",
  dashboard: "Dashboard",
  settings: "Einstellungen",
  views: "ansichten",
  times_seen: "mal gesehen",
  in_search: "in der Suche",
  reset_password: "Passwort zurücksetzen",
  submit: "Bestätigen",
  password: "Passwort",
  email: "E-Mail",
  confirm_password: "Passwort bestätigen",
  reset_email: "E-Mail zurücksetzen",
  update: "Aktualisieren",
  new_email: "Neue E-Mail",
  kjuup_message: "Kjuup Nachricht",
  my_position: "Meine Position:",
  owner_company_admin: "Inhaber-Firmenadministrator :",
  owner_company_admin_new: "Firmenadmin",
  co_owner: "Mitinhaber/in",
  managing_director: "Geschäftsführer/in",
  associate: "Partner/in",
  secretary: "Sekretär/in",
  your_position_within_company: "Wähle bitte deine Position in der Firma",
  employee: "Mitarbeiter/in",
  project_manage: "Projektmanager/in",
  delete_profile: "Profil löschen?",
  auto_chat_translation: "Automatische Chat-Übersetzung",
  auto_translation_languages_title: "Sprachen für automatische Übersetzung",
  auto_translation_languages_info: "Wählen Sie, welche Nachrichtensprachen automatisch in Ihre Oberflächensprache übersetzt werden sollen. Deaktivieren Sie eine Sprache, um Nachrichten in dieser Sprache im Original zu belassen.",
  auto_translation_languages_save: "Übersetzungssprachen speichern",
  auto_translation_languages_saved: "Einstellungen für Übersetzungssprachen gespeichert",
  auto_translation_languages_your_language: "Ihre Sprache",
  translate_room_group_names: "Chatgruppennamen übersetzen",
  translate_room_group_names_info: "Wenn aktiviert, werden Chatgruppennamen automatisch in Ihre Oberflächensprache übersetzt.",
  email_summary_preview: "E-Mail-Zusammenfassung als Vorschau",
  email_summary_preview_info: "Wenn aktiviert, zeigt die Nachrichtenliste eine einzeilige Zusammenfassung jeder E-Mail. Wenn deaktiviert, wird der erste Satz der E-Mail angezeigt.",
  default_view_email: "Standardansicht: E-Mail",
  default_view_email_info: "Wenn aktiviert, wird beim Öffnen der App standardmäßig der E-Mail-Tab anstatt Nachrichten geöffnet.",
  integrate_email_in_messages: "E-Mail & Nachrichten kombinieren",
  integrate_email_in_messages_info: "Wenn aktiviert, werden E-Mails aller verbundenen Konten zusammen mit Ihren Chat-Nachrichten nach Datum sortiert angezeigt.",
  language: "Sprache",
  english: "Englisch",
  german: "Deutsch",
  french: "Französisch",
  italian: "Italienisch",
  change_language: "Sprache ändern",
  my_companies: "Meine Firmen",
  employees: "Mitarbeitende",
  invite_with_a: "Zu Kjuup einladen",
  add_member: "Mitglied hinzufügen",
  room_action_members: "Mitglieder",
  room_action_add: "Hinzufügen",
  room_action_media: "Dateien",
  room_tab_overview: "Übersicht",
  room_tab_history: "Verlauf",
  room_overview_status_title: "Aktueller Stand",
  room_overview_as_of: "Stand: {{time}}",
  room_overview_empty: "Noch kein Stand für dieses Projekt",
  room_overview_empty_hint: "Der Stand wird jede Nacht für Projekte mit neuen Nachrichten, E-Mails oder Aufgaben geschrieben.",
  room_overview_priorities_title: "Aktueller Status und Prioritäten",
  room_overview_no_priorities: "Keine offenen Prioritäten im letzten Bericht.",
  room_overview_priority_no_detail: "Der Bericht nennt keine weiteren Details zu dieser Priorität.",
  room_overview_priority_from: "Quelle: {{name}}",
  room_overview_priority_open_task: "Aufgabe öffnen",
  cockpit_priority_position: "{{index}} von {{total}} Prioritäten",
  room_overview_today_title: "Heute wichtig",
  room_overview_all_tasks: "Alle",
  room_overview_tasks_empty: "Keine offenen Fristen oder Aufgaben",
  room_overview_appointments_empty: "Keine anstehenden Termine",
  pro_todo_room_empty_today: "Heute keine Aufgaben in diesem Projekt",
  pro_todo_room_empty_day: "An diesem Tag keine Aufgaben in diesem Projekt",
  create_chat: "Chat erstellen",
  create_email: "E-Mail erstellen",
  add_user: "Teilnehmer*in",
  send_location: "Standort senden",
  assign_admin_rights: "Adminrechte anpassen",
  deactivate_company: "Firma deaktivieren",
  no_user_found: "Keine Nutzer gefunden!",
  remove_employees: "Mitarbeiter/in entfernen",
  remove_members: "Mitglieder entfernen",
  translation_on_building_projects: "Übersetzungsfunktion in Projekten",
  reported_capacities: "Angebotene Leistungen",
  see_more: "...mehr",
  see_less: "...weniger",
  up_to_50m_exact: "Bis zu 50m genau",
  invite_with_link: "Zu Kjuup einladen",
  share_link: "Einen Link teilen",
  share_company_link: "Link teilen",
  approve: "Bestätigen!",
  qr_code: "QR-Code",
  copy_link: "Link kopieren",
  cancel_link: "Link abbrechen",
  who_has_confirmed_services: "Wer hat deine Leistungen bestätigt?",
  add_services: "Firmenleistungen hinzufügen",
  save_text: "speichern",
  share_on: "Teilen auf:",
  link_copied: "Link kopiert!",
  email_copied: "Email kopiert!",
  personal_article: "Persönlicher Artikel",
  comapny_article: "Firmenartikel",
  characters_remaining: "verbleibende Zeichen",
  artical_text: "Artikel verfassen...",
  optional_information: "Optionale Information",
  project: "Projekt",
  projects: "Projekte...",
  projectss: "Projekte",
  abort: "Verwerfen",
  preview: "Vorschau",
  post: "Veröffentlichen",
  remove: "Entfernen",
  free_capacity: "Auftragsportal",
  current_status_overview: "Übersicht über den aktuellen Status",
  report_capacities: "Leistungen anbieten",
  report_text: "Anbieten",
  search_capacities: "Auftragnehmer finden",
  find: "Finden",
  add_project_user: "Projektbenutzer hinzufügen",
  media: "Medien",
  links: "Links",
  docs: "Doks",
  media_filter_photos: "Fotos",
  media_filter_docs: "Dokumente",
  media_filter_source: "Quelle",
  featured_products: "Ausgewählte Produkte...",
  title: "Titel",
  text: "Text",
  select_profile_image: "Wähle ein Profilbild",
  feed_details: "Feed-Details",
  add_employee: "Mitarbeitende hinzufügen",
  my_projects: "Meine Projekte",
  cancel: "Abbrechen",
  add_company_cancel: "Abbrechen",
  continue: "Fortsetzen",
  role_in_the_building_industry: "Branche",
  close: "Schließen",
  close_modal: "Abbrechen",
  services: "Firmenleistungen",
  request_to_join_a_company: "Anfrage zum Beitritt bei der Firma",
  wants_to_join_the_company: "möchte der Firma",
  als: "als",
  join: "beitreten",
  filter_by: "Filtern nach",
  ok: "OK",
  latest: "Aktuell",
  weekly_statistics: "Wöchentliche Statistik",
  time: "Zeit",
  in_searches_in_past_week: " in Suchanfragen erschienen.",
  is_following_you: "hat sie abonniert.",
  has_liked_your_article: "gefällt ihr Artikel.",
  has_published_a_new_article: " hat einen neuen Artikel veröffentlicht.",
  as: "wie",
  has_joined_the: "ist der Firma",
  has_looked_at_your_profile: "hat sich ihr Profil angesehen.",
  you: "Sie",
  have_joined_the: "haben sich dem Projekt",
  building_project: " Bauprojekt.",
  all_views: "Alle Ansichten",
  you_have_been_found: "Sie wurden in der letzten Woche",
  all_profile_views: "Alle Profilansichten",
  mutual_company: "gemeinsame Firma",
  mutual_companys: "gemeinsame Firmen",
  you_have_appeared: " Du bist in der letzten Woche",
  your_request_at_the_company: "Ihre Anfrage bei der Firma",
  has_been_confirmed: "wurde bestätigt.",
  improve_profile: "Profil verbessern",
  choose_existing_contact_for_single_chat:
    "Wähle einen vorhandenen Kontakt für einen einzelnen Chat:",
  in_order_to_add_new_contacts:
    "Um neue Kontakte hinzuzufügen, suche bitte auf der Profilseite nach neuen Kontakten.",
  times_in_searches_in_the_last_week:
    "Mal in Suchanfragen gefunden. Aktualisiere dein Profil und füge weitere Details hinzu, um leichter gefunden zu werden.",
  appear_more_often_in_searches: "Erscheine häufiger in Suchanfragen",
  times_you_have_appeared_in_searches:
    "Mal bist du in Suchanfragen erschienen",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Wähle die Firma, die du vertreten wirst. Dies wird anderen Teilnehmern angezeigt.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Wähle die Firma, die du vertreten wirst. Dies wird anderen Teilnehmern angezeigt.",
  select_internal_section: "Bitte internen Bereich auswählen",
  share_user: "Benutzer teilen",
  contact_sender_message:
    "Teile diesen Link, um ein/mehrere Nicht-Mitglied/er von Kjuup zu Kjuup einzuladen. Dieser Link kann von mehreren Personen zur Registrierung genutzt werden.",
  project_sender_message:
    "Teile diesen Link, um ein Nicht-Mitglied von Kjuup zum Projekt project name einzuladen. Diesen Link können mehrere Personen zur Registrierung und zum Beitritt beim Projekt in Kjuup nutzen.",
  company_sender_message:
    "Teile diesen Link, um ein Nicht-Mitglied von Kjuup zur Firma company name einzuladen. Diesen Link können mehrere Personen zur Registrierung und zum Beitritt bei der Firma in Kjuup nutzen.",
  contact_receivers_message:
    "Einladungslink, um Kjuup beizutreten. Bitte klicke auf den Link, um dich bei Kjuup zu registrieren.",
  iphone_recivers_message:
    "Falls du Kjuup über den Apple App Store installierst, musst du nach dem Download noch diesen Link klicken, um dich registrieren zu können.",
  iphone: "iPhone:",
  project_receivers_message:
    "Einladungslink zum Projekt project name in Kjuup. Bitte klicke auf den Link, um dich bei Kjuup zu registrieren und dem Projekt project name beizutreten.",
  company_receivers_message:
    "Einladungslink zur Firma company name in Kjuup. Bitte klicke auf den Link, um dich bei Kjuup zu registrieren und der Firma company name beizutreten.",
  sign_in: "Anmelden",
  enter_your_email_add: "E-Mail eingeben",
  forgot_password: "Passwort vergessen",
  dont_have_account: "Sie haben kein Konto ?",
  register: "Registrieren",
  get_app: "Hol dir die App",
  registration: "Registrierung",
  dep_ing: "Dipl.-Ing.",
  dr: "DR.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architekt",
  prof: "Prof.",
  first_name: "Vorname",
  last_name: "Nachname",
  have_an_account: "Ein Konto haben ?",
  when_register_you_agree: "Indem du dich registrierst, stimmst du unseren",
  term_of_use: "Nutzungsbedingungen",
  in_our: "In unseren",
  to: "zu.",
  data_policy: "Datenrichtlinien",
  they_find_out: "erfährst du,",
  we_provide_store_data:
    "wie wir Informationen erfassen, verarbeiten und speichern. ",
  leaving_company_text:
    "Willst du die Firma wirklich verlassen? Wenn du die Firma verlässt, verlässt du auch alle mit der Firma verbundenen Projekte und Chats. Du kannst diesen jederzeit erneut mit einer anderen Firma beitreten.",
  delete_profile_text:
    "Willst du dein Profil wirklich löschen? Wenn du dein Profil löschst, werden alle Verbindungen zu Firmen, Projekten und Chats entfernt. Du kannst jederzeit ein neues Profil anlegen.",
  confirm: "Bestätigen",
  reject: "Ablehnen",
  requet_to_leave: "Firma verlassen",
  choose: "Wählen Sie",
  your_add_member: "Mitglied hinzufügen",
  if_you: "wenn Sie",
  can_not_find: "Ihren Kontakt hier nicht finden können.",
  please_wait: "Warte mal..",
  imprint_gtc: "Impressum/AGB",
  register_confirm_title: "Bitte bestätigen Sie Ihre E-Mail, bevor Sie sich anmelden",
  register_confirm_popup:
    "Bitte bestätigen Sie Ihre Kjuup-E-Mail-Adresse, bevor Sie sich anmelden. Ohne diese Bestätigung ist kein Login möglich. Wir haben Ihnen einen Bestätigungslink gesendet. Falls Sie die Nachricht nicht finden, prüfen Sie bitte auch Ihren Spam-Ordner.",
  resend_confirmation_email: "Bestätigungs-E-Mail erneut senden",
  resend_confirmation_sent: "Falls diese E-Mail-Adresse auf eine Bestätigung wartet, haben wir einen neuen Link gesendet.",
  PENDING_GROUP_USER:
    "erhält Nachrichten erst nachdem er/sie die Einladung zum Projekt bestätigt hat. Sobald er/sie die Einladung bestätigt oder abgelehnt hat wird dies hier angezeigt.",
  PENDING: "Bestätigung der Einladung zum Projekt ausstehend",
  denied_group_chat:
    " hat die Einladung zum Projekt abgelehnt und den Chat verlassen.",
  joined_group_chat: " ist dem Chat beigetreten.",
  you_joined_group_chat: "Sie sind dem Chat beigetreten.",
  Others: "Andere",
  LEFT_GROUP: "hat den Chat verlassen.",
  YOU_LEFT_GROUP: "haben den Chat verlassen.",
  days: "Tage",
  day: "Tag",
  hour: "Std.",
  hide_project: "Projekt verbergen",
  hide_project_popup_text:
    "Wenn du Projekte verbirgst, können diese in Kjuup nicht mehr gefunden werden. Nur Mitglieder des Projekts können weitere Mitglieder einladen.",
  branch: "Branche",
  photo_video_media_lib: "Foto- und Videomediathek",
  video_too_large: "Videos dürfen höchstens 200 MB groß sein.",
  video_too_long: "Videos dürfen höchstens 15 Minuten lang sein.",
  video_invalid: "Dieses Video konnte nicht gelesen werden.",
  video_one_at_a_time: "Bitte nur ein Video auf einmal auswählen.",
  video_or_images_only: "Bitte entweder Bilder oder ein einzelnes Video auswählen.",
  video_processing: "Video wird komprimiert…",
  video_uploading: "Video wird hochgeladen…",
  article_publish_preparing: "Wird vorbereitet…",
  article_publish_compressing_video: "Video wird komprimiert…",
  article_publish_preparing_media: "Fotos werden vorbereitet…",
  article_publish_uploading: "Medien werden hochgeladen…",
  article_publish_finishing: "Wird veröffentlicht…",
  document: "Dokument",
  location: "Standort",
  location_meeting: "Standort",
  all_member_of_project: "Alle Mitglieder des Projekts",
  pending_request: "Ausstehende Projekteinladungen",
  no_pending_request: "Keine ausstehenden Einladungen zu Projekten",
  news_feed: "News-Feed",
  user_info: "Gruppen Info",
  leave_project: "Projekt verlassen",
  media_link_docs: "Dateien",
  search_chat: "Chat durchsuchen",
  export_chat_group: "Chat-Daten exportieren",
  export_chat_timeframe: "Zeitraum",
  export_chat_last_week: "Letzte Woche",
  export_chat_last_month: "Letzter Monat",
  export_chat_last_3_months: "Letzte 3 Monate",
  export_chat_custom: "Benutzerdefiniert",
  export_chat_from: "Von",
  export_chat_to: "Bis",
  export_chat_start: "Exportieren",
  export_chat_progress_fetching: "Nachrichten werden geladen...",
  export_chat_progress_generating: "PDF wird erstellt...",
  export_chat_progress_downloading: "Wird heruntergeladen...",
  export_chat_progress_done: "Export abgeschlossen",
  export_chat_progress_error: "Export fehlgeschlagen",
  export_chat_no_messages: "Keine Nachrichten in diesem Zeitraum gefunden",
  export_chat_invalid_range: "Bitte einen gültigen Zeitraum wählen",
  request_complete_chat_history: "Gesamten Chatverlauf anfordern",
  leave_chat_group: "Chat verlassen",
  add_user_project: "Teilnehmer*in hinzufügen",
  me: "Ich",
  request_confirmation: 'Ausstehende Projekteinladungen',
  max_open_one_to_one:
    "Derzeit können max. 2 Einzelchats parallel im oberen - und im unteren Bereich geöffnet werden. Insgesamt können max. 4 Einzelchats geöffnet werden.",
  are_you_sure_you_want_leave_chat:
    "Willst du den Chat wirklich verlassen?",
  create_group: "Gruppe erstellen",
  adding_members: "Mitglieder hinzufügen...",
  creating_the_chat: "Chat wird erstellt...",
  finishing_setup: "Wird abgeschlossen...",
  group_name: "Gruppenname",
  by: "Von:",
  mandetory: "*Pflichtfeld",
  delteed: "hat sein/ihr Profil gelöscht und den Chat verlassen.",
  deleted_direct: "hat sein/ihr Profil gelöscht und den Chat verlassen.",
  unhidden_message:
    "Wenn du Projekte sichtbar machst, können diese in Kjuup von allen Kjuup Mitgliedern gefunden werden.",
  account_deleted: "Account wurde gelöscht.",
  refuse_company:
    "Bist du sicher, dass du die Anfrage zum Beitritt bei der Firma ablehnen möchtest?",
  follow_additional: "Weitere Teilnehmer*innen abonnieren",
  f_add:
    "Weitere Teilnehmer*innen in Kjuup abonnieren, um mit ihnen per Direktnachricht zu kommunizieren.",
  c_inv: "Firmeneinladung(en)",
  invited_o_Company: "Sie wurden zur Firma",
  refuse_companyX:
    "Bist du sicher, dass du die Einladung zur Firma ablehnen möchtest?",
  a_Da: "Konto wurde deaktiviert.",
  has_deactivated: "hat sein/ihr Profil deaktiviert.",
  reactive: "hat sein/ihr Profil reaktiviert.",
  email_username: "E-Mail/Benutzername*",
  kjuup_note:
    "*Registrierung mit Benutzername nur für Teilnehmer/innen von Kjuup+ möglich.",
  username: "Benutzername*",
  sPinText:
    "Bitte erstelle deinen persönlichen 6-stelligen Pin. Der Pin wird benötigt, falls du dein Passwort vergisst und wird als Kontobestätigung vorausgesetzt.",
  DeleteKjuupPlusText:
    "Willst du dein Profil wirklich löschen? Wenn du dein Profil löschst, werden alle Verbindungen zu Firmen, Projekten und Chats entfernt.\n\nDu kannst dein Profil innerhalb von 48 Stunden reaktivieren, indem du dich mit deinem Benutzernamen, Passwort und Pin bei Kjuup anmeldest. ",
  reactive_text:
    "Dein Konto wurde gelöscht. Bitte klicke auf Reaktivieren um dein Konto zu reaktivieren.",
  rac: "Reaktivieren",
  ac_ss: "Konto wurde erfolgreich reaktiviert.",
  not_valid_pin: "Pin ungültig",
  only_for_kjuup:
    "*Password zurücksetzen via Benutzername und Pin nur für Teilnehmer/innen von Kjuup+ möglich.",
  resetPIN: "PIN zurücksetzen",
  enter_current_pin: "Bitte gib deinen aktuellen PIN ein",
  enter_new: "Bitte neuen PIN eingeben",
  pin_to_confirm: "PIN eingeben, um zu bestätigen.",
  change_username: "Benutzernamen zurücksetzen",
  pp_not_match: "Passwort und Passwortbestätigung stimmen nicht überein",
  reactive_itself: "Du hast dein Profil reaktiviert.",
  has_deactivated_itself: "Du hast dein Profil deaktiviert.",
  more_than_two:
    "Derzeit können Direktnachrichten mit max. 2 Personen parallel ausgeführt werden.",
  Chats: "Direktnachrichten",
  only_in_mobileL:
    "Native Videos können derzeit nur via mobiler App hochgeladen und geposted werden. Verwende jederzeit gerne Video-Links von Youtube oder Vimeo.",
  register_pin_text:
    "Wähle bitte deinen persönlichen 6-stelligen PIN. Dieser wird beim Zurücksetzen einzelner Kontodetails benötigt.",
  internal_project: "Intern",
  external_projects: "Extern",
  in_deacticted: "Interner Bereich ist deaktiviert.",
  create_article: "Artikel erstellen",
  new_article_selection: "Artikel für externen News-Feed erstellen",
  new_article_selection_internal: "Firmeninternen Artikel erstellen",
  active_trans_title: "Automatische Übersetzung aktivieren?",
  active_trans: "Wenn aktiviert, werden alle eingehenden Chat-Nachrichten in deine ausgewählte App-Sprache übersetzt.",
  disable_trans: "Willst du die automatische Übersetzung deaktivieren?",
  allow_access_chat: "Kompletten Chatverlauf anzeigen",
  toggle_chat_history_on:
    "Willst du wirklich, dass der/die Teilnehmer/in den kompletten Chatverlauf einsehen kann?",
  toggle_chat_history_off:
    "Willst du wirklich, dass der/die Teilnehmer/in den Chatverlauf erst ab dem Zeitpunkt des Beitritts einsehen kann?",
  check_selected_settings:
    "Bitte die Einstellungen zum Chatverlauf bei allen ausgewählten Teilnehmer/innen kontrollieren!",
  chat_from_start_have:
    "Sie sind dem Chat beigetreten. Der Chatverlauf wurde mit Ihnen geteilt.",
  chat_from_start_has:
    "ist dem Chat beigetreten. Der Chatverlauf wurde mit ihm/ihr geteilt.",
  Address: "Address",
  read_by: "Gelesen von",
  deliver_to: "Zugestellt an",
  remaining: "ausstehend",
  message_info: "Nachrichteninfo",
  request_to_join_only: "Teilnahme anfragen",
  unfollow: "Entfernen",
  company_username: "Benutzername",
  month: [
    "Jan",
    "Feb",
    "März",
    "Apr",
    "Mai",
    "Juni",
    "Juli",
    "Aug",
    "Sept",
    "Okt",
    "Nov",
    "Dez",
  ],
  remove_my_admin_right: "Meine Adminrechte entfernen",
  makeEmp:
    "Willst du dem/der Teilnehmer*in wirklich Adminrechte bei der Firma entziehen?",
  makeAdmin:
    "Willst du dem/der Teilnehmer*in wirklich Adminrechte für die Firma zuweisen?",
  remove_my_self:
    "Willst du dir wirklich Adminrechte bei der Firma entziehen?",
  remove_member: "Mitarbeiter/in entfernen",
  remove_following_confirm: "Willst du {name} wirklich aus der Liste Abonniert entfernen?",
  remove_follower_confirm: "Willst du {name} wirklich aus der Liste der Abonnenten entfernen? Wenn du ihn/sie entfernst, wird er/sie nicht darüber informiert.",
  do_you_really_want_to_remove:
    "Willst du den/die Mitarbeiter/in username wirklich aus der Firma entfernen?",
  dep_loc: "Abteilung/Standort/Team",
  notify_employees_via_dm: "Mitarbeiter per Direktnachricht informieren",
  notify_employees_via_dm_hint: "Sendet beim Veröffentlichen eine Chat-Nachricht von deinem Konto an Mitarbeiter der ausgewählten Abteilungen, Standorte oder Teams.",
  notify_employees_via_dm_hint_edit: "Sendet eine Chat-Nachricht von deinem Konto an Mitarbeiter der ausgewählten Abteilungen, Standorte oder Teams über die Änderungen.",
  depAdmin: "Abteilungsadmin",
  add_remove_admin: "Firmenadmin hinzufügen/entfernen",
  add_remove_dep_admin: "Abteilungsadmin hinzufügen/entfernen",
  remove_employees_dept: "Mitarbeiter/in entfernen aus",
  want_to_join_dep:
    "Username möchte Abteilung/Standort/Team depname von der Firma companyname beitreten.",
  you_invited:
    "Sie wurden zu Abteilung/Standort/Team depname bei der Firma companyname eingeladen.",
  dep_remove:
    "Willst du dem/der Teilnehmer*in wirklich Adminrechte für die Abteilung / Standort entziehen?",
  add_dep:
    "Willst du dem/der Teilnehmer*in wirklich Adminrechte für die Abteilung / Standort zuweisen?",
  my_self_dep_remove:
    "Willst du dir wirklich die Rechte als Abteilungsadmin entziehen?",
  company_sender_message_dep:
    "Einladungslink zu depname in der Firma company name in Kjuup. Bitte klicke auf den Link, um dich bei Kjuup zu registrieren und der Firma company name beizutreten.",
  invite_all: "Alle Mitarbeiter/innen der Firma einladen",
  invite_all_members: "Alle Teilnehmer/innen einladen",
  mems: "Alle weiteren Teilnehmer/innen",
  member: "Mitglied",
  admin: "Admin",
  remove_project_admin:
    "Willst du das Mitglied wirklich aus dem Projekt entfernen?",
  remove_my_self_project: "Willst du dir wirklich Adminrechte entziehen?",
  remove_member_admin_right:
    "Willst du dem Admin wirklich Adminrechte entziehen?",
  add_member_admin_right:
    "Willst du dem Mitglied wirklich Adminrechte zuweisen?",
  add_remove_Poss: "Admin hinzufügen/entfernen",
  forward: "Weiterleiten",
  forward_to: "Weiterleiten an...",
  tap_to_forward: "Tippe einen Chat zum Senden",
  new_conversation: "Neuer Chat",
  room_create_kjuup_chat: "Kjuup-Chat",
  room_create_email: "E-Mail",
  room_create_teams_chat: "Teams-Chat",
  select_more_messages: "Weitere Nachrichten auswählen",
  message: "Nachricht",
  messages: "Nachrichten",
  edit: "Editieren",
  only_kjuup_plus_can: "Nur Kjuup+ Firmen können Artikel posten.",
  add_images: "Bilder hinzufügen",
  add_images_or_pdf: "Bilder, Videos oder PDFs hinzufügen",
  drop_files_here: "Dateien hier ablegen",
  drag_and_drop_hint_pdf: "oder Bilder/Videos/PDFs hier hineinziehen",
  unsupported_file_type: "Nicht unterstützter Dateityp. Nur Bilder, Videos und PDFs sind erlaubt.",
  max_file_size_exceeded_25mb: "Max. Größe von 25MB überschritten. Bitte eine kleinere Datei wählen.",
  Activity: "Aktivität",
  latest_messages: "Letzte Nachrichten",
  hours: "Std.",
  minute: "Minuten",
  seconds: "Sekunde",
  days: "Tage",
  yesterday: "Gestern",
  last_week: "Letzte Woche",
  this_week: "Diese Woche",
  next_week: "Nächste Woche",
  Last_month: "Letzter Monat",
  this_month: "Diesen Monat",
  All: "Alle",
  register_plus: "Registrierung Plus",
  select_files: "Medien auswählen",
  monthsFullName: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
  company_deploc_receivers_message:
    "Einladungslink zu department in der Firma company name in Kjuup. Bitte klicke auf den Link, um dich bei Kjuup zu registrieren und der Firma company name beizutreten.",
  no_news: "Keine Mitteilungen vorhanden",
  reminder: "Erinnerungen",
  np_reminder: "Keine Aufgaben",
  move_to_reminder: "Als Aufgabe speichern",
  remove_reminder:
    "Willst du die Nachricht wirklich von der Liste deiner Aufgaben entfernen?",
  remove_all_reminder: "Alle Aufgaben entfernen",
  remove_all_confirm:
    "Willst du wirklich alle Nachrichten von der Liste deiner Aufgaben entfernen?",
  remove_from_reminder: "Von Aufgaben entfernen",
  prevent_email: "Eine E-Mail kann nicht als Benutzername angegeben werden.",
  allow_noti: "Bitte erlaube Benachrichtigungen.",
  join_cap: "Beitreten",
  pass_minimum:
    "**Passwort muss 12 Zeichen inkl. Klein-, Großbuchstabe, Nummer und Sonderzeichen beinhalten.",
  pass_error: "Bitte Passwortanforderungen überprüfen",
  frequent: "Zuletzt verwendet",
  people: "Smileys und Emotionen",
  people_that_like_article: "Personen, denen dein Artikel gefällt.",
  people_who_like_article: "Personen, denen der Artikel gefällt.",
  show_draft: "Entwurf anzeigen...",
  draft_prefix: "Entwurf:",
  message_delete: "Diese Nachricht wurde gelöscht.",
  message_edited: "bearbeitet",
  edit_message: "Nachricht bearbeiten",
  edit_window_expired: "Nachrichten können nur innerhalb von 10 Minuten nach dem Senden bearbeitet werden.",
  message_edit_save: "Speichern",
  copy: "Kopieren",
  bookmark: "Merken",
  add_reaction: "Reaktion hinzufügen",
  delete_message: "Nachricht löschen",
  more_options: "Mehr Optionen",
  reacted_with: "reagierte mit",
  delete_message_confirm: "Möchtest du diese Nachricht wirklich löschen?",
  link_invite: "Per Link einladen",
  ll_nkk: "Zu Kjuup einladen",
  selected: "Ausgewählt",
  is_active: "Aktiv",
  inactive: "Inaktiv",
  last_online: "zuletzt online {{when}}",
  remove_user_l: "Entfernen",
  assign_group_admin_rights: "Adminrechte zuweisen",
  remove_group_admin_rights: "Adminrechte entziehen",
  link_expire: "Jeder generierte Link ist 72 Stunden gültig.",
  company_language: "Firmensprache",
  settings_admin_info: "Informationen",
  settings_admin_departments: "Abteilungen und Mitarbeiter",
  settings_admin_notifications: "Benachrichtigungen",
  settings_admin_translation: "Übersetzungssprachen",
  settings_admin_startup: "Startbildschirm",
  settings_admin_my_space: "My Space",
  settings_admin_add_employees: "Mitarbeitende hinzufügen",
  settings_admin_project_partners: "Projektpartner hinzufügen",
  settings_admin_partner_companies: "Partnerfirmen hinzufügen",
  settings_admin_rooms: "Projekte / Chats",
  settings_admin_documents: "Firmendokumente",
  settings_admin_articles: "Artikel",
  settings_admin_article_translations: "Übersetzungen für interne Artikel",
  company_language_info:
    "Die Sprachauswahl wird für alle E-Mail Bestätigungen, die die Firma betreffen, verwendet.",
  article_translation_target_languages_title: "Sprachen für Artikelübersetzung",
  article_translation_target_languages_info:
    "Wähle aus, in welche Kjuup-Oberflächensprachen die Artikel dieser Firma übersetzt werden sollen. Standardmäßig gelten dieselben Sprachen wie bei externen Artikeln. Firmenadmins können die Liste anpassen.",
  article_translation_target_languages_save: "Speichern",
  article_translation_languages_saved: "Sprachen für Artikelübersetzung gespeichert",
  article_original_language: "Originalsprache",
  article_original_language_info:
    "Die Sprache, in der der Artikel verfasst ist. Der Artikel wird nicht in diese Sprache übersetzt.",
  s_image: "Bild",
  m_image: "Bilder",
  removeMsg: "Tippen zum Entfernen",
  block: 'Blockieren',
  unblock: 'Entblocken',
  blocks: 'Willst du den/die Benutzer*in wirklich blockieren?',
  unblocks: 'Willst du den/die Benutzer*in wirklich entblocken?',
  bolcked_click_un_block:
    'Du hast den Kontakt blockiert. Klicke hier um ihn zu entblocken.',
  you_blocked_contact: 'Sie haben den Kontakt geblockt.',
  you_unblocked_contact: 'Sie haben den Kontakt entblockt.',
  you_have_unblocked: 'Sie haben den Kontakt entblockt.',
  you_have_blocked: 'Sie haben den Kontakt blockiert.',
  unblock_to_send:
    'Entblocke den/die Benutzer*in um Nachrichten zu senden.',
  back: 'Zurück',
  pilot_text:"Spezialisierte KI für Bau-Themen",
  support_text:"Chat mit Kjuup Support",
  todo_notification_label: "Zähler und Push-Benachrichtigungen für zugewiesene Aufgaben",
  todo_notification_info: "Du wirst benachrichtigt, sobald dir eine neue Aufgabe zugewiesen wird.",
  email_push_notification_label: "Push-Benachrichtigungen für neue E-Mails",
  email_push_notification_info: "Du wirst benachrichtigt, sobald eine neue E-Mail in deinem Posteingang ankommt.",
  email_push_notification_io_only: "Nur mit Kjuup.io verfügbar – die E-Mail-Integration ist Teil des Kjuup.io-Abos.",
  daily_briefing_label: "Tagesbericht",
  daily_briefing_info: "Erstellt täglich einen Tagesbericht für alle Projekte in Nachrichten zur Uhrzeit, die du unten festlegst, wenn ein E-Mail-Konto verbunden ist und mindestens ein Projekt Aktivität hatte. Es wird nicht per E-Mail versendet.",
  daily_briefing_notification_label: "Zähler Benachrichtigungen für Tagesbericht",
  daily_briefing_notification_info: "Zeigt die Anzahl ungelesener Tagesberichte am Projekt-Symbol, am betreffenden Projekt und am Tagesbericht-Tab.",
  daily_briefing_hour_label: "Uhrzeit für den Tagesbericht",
  daily_briefing_hour_info: "Der Tagesbericht wird zu dieser Uhrzeit (Europe/Berlin) erstellt. Ist die Uhrzeit heute schon vorbei, wird er in Kürze erzeugt.",
  daily_briefing_hour_saved: "Uhrzeit für den Tagesbericht aktualisiert",
  daily_briefing_model_label: "KI-Modell für den Tagesbericht",
  daily_briefing_model_internal: "Intern (Kjuup-KI)",
  daily_briefing_model_external: "Extern (Mistral)",
  daily_briefing_model_internal_info: "Läuft auf Kjuup-eigenen Servern. Inhalte verlassen Kjuup nicht.",
  daily_briefing_model_external_info: "Neuestes passendes Modell von Mistral AI (Frankreich). Inhalte aus Ihren Projekten werden zur Erstellung an Mistral übermittelt.",
  daily_briefing_model_info: "Gilt ab dem nächsten Tagesbericht.",
  daily_briefing_model_saved: "KI-Modell für den Tagesbericht aktualisiert",
  room_daily_briefing_label: "Individueller Projekt-Tagesbericht",
  room_daily_briefing_info: "Wenn aktiviert, wird alle 24 Stunden zur in den persönlichen Einstellungen festgelegten Uhrzeit ein Tagesbericht für dieses Projekt erstellt — jedoch nur, wenn in diesem Zeitraum Aktivität stattgefunden hat.",
  email_style_personalization_label: "Meinen Schreibstil für E-Mail-Vorschläge nutzen",
  email_style_personalization_info: "Wenn aktiv, lernen Antwortvorschläge von deinen gesendeten E-Mails und Chats. Die Originaltexte werden nicht gespeichert.",
  email_style_rebuild: "Schreibstil zurücksetzen",
  email_style_rebuild_confirm_title: "Schreibstil zurücksetzen?",
  email_style_rebuild_confirm: "Der bisher gelernte Schreibstil wird verworfen und aus deinen aktuellen gesendeten E-Mails und Chats neu aufgebaut.",
  email_style_rebuild_confirm_ok: "Zurücksetzen",
  email_style_rebuilt: "Schreibstil wurde zurückgesetzt.",
  email_style_rebuild_failed: "Schreibstil konnte nicht zurückgesetzt werden.",
  email_suggestion_concise: "Kurz",
  email_suggestion_balanced: "Ausgewogen",
  email_suggestion_warm: "Freundlich",
  email_suggestion_regenerate: "Neu erzeugen",
  email_suggestion_shorter: "Kürzer",
  email_suggestion_more_formal: "Formeller",
  email_suggestion_friendlier: "Lockerer",
  email_suggestion_overwrite: "Den bereits eingegebenen Text durch diesen Vorschlag ersetzen?",
  email_suggestion_replace: "Ersetzen",
  email_suggestion_check_recipient: "Bitte die Anrede prüfen — der Empfänger konnte nicht sicher erkannt werden.",
  email_suggestion_review: "Diesen Entwurf vor dem Senden prüfen. Er kann angenommene Details enthalten.",
  email_suggestion_error: "Vorschläge konnten nicht geladen werden.",
  startup_screen_label: "Startbildschirm",
  startup_screen_info: "Wähle, welcher Bildschirm beim Start von Kjuup geöffnet wird.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Nachrichten",
  startup_screen_saved: "Startbildschirm aktualisiert",
  email_on: "E-Mail Benachrichtigung Chats",
  email_on_grp: "E-Mail Benachrichtigung",
  article_email_on: "E-Mail Benachrichtigung Artikel",
  article_email_info: "Wenn du E-Mail-Benachrichtigungen für interne Artikel aktivierst, erhältst du eine E-Mail, sobald ein neuer interner Artikel in deiner Firma und deiner Abteilung veröffentlicht wird.",
  info_email_room: "Aktiviere oder deaktiviere E-Mail Benachrichtigungen für dieses Projekt. Diese Option ist nur verfügbar, wenn \"E-Mail Benachrichtigung Chats\" in den persönlichen Einstellungen aktiviert ist. ",
  info_val: "Du erhältst eine E-Mail, wenn eine neue Chat-Nachricht nicht innerhalb kurzer Zeit gelesen wird. Einzelne Projekte oder Chats kannst du in deren Einstellungen bzw. in der Gruppeninfo deaktivieren.",
  email_groups: "Aktiviere oder deaktiviere E-Mail Benachrichtigungen für diesen Chat. Diese Option ist nur verfügbar, wenn \"E-Mail Benachrichtigung Chats\" in den persönlichen Einstellungen und in den Projekteinstellungen aktiviert ist.",
  add_update_email: "E-Mail hinzufügen/aktualisieren",
  add_update_email_for_notifications: "E-Mail für E-Mail Benachrichtigungen hinzufügen/aktualisieren",
  text_to_verifiy:"Die Option \"E-Mail-Benachrichtigungen Chats\" kann nur aktiviert werden, wenn du eine bestätigte E-Mail hinterlegt hast.",
  stored_email:"Hinterlegte E-Mail: ",
  verify_email:"Bestätigung ausstehend!",
  verified:"Verifiziert",
  join_call:"Beitreten",
  call_is_started:"Anruf gestartet",
  start_chat:"Direkt-Chat starten?",
  start_chat_button:"Neue Nachricht",
  start_direct_message: "Direktnachricht starten?",
  project_rooms:"Projekte",
  download_selected: "Herunterladen",
  download_to_folder: "In Ordner speichern",
  download_as_zip: "Als ZIP herunterladen",
  media_download_progress: "Lade {current} von {total} herunter",
  media_downloaded_on: "Bilder heruntergeladen am {datetime}",
  docs_downloaded_on: "Dokumente heruntergeladen am {datetime}",
  media_auto_download: "Automatischer Medien-Download",
  media_auto_download_hint: "Neue Bilder und Dokumente werden um 20:00 Uhr gespeichert",
  media_auto_download_info: "Wähle einmal einen Ordner. Neue Bilder und Dokumente aus diesem Chat oder Projekt werden dort jeden Tag um 20:00 Uhr automatisch gespeichert. Ist Kjuup zu diesem Zeitpunkt geschlossen, erfolgt der Download beim nächsten Öffnen der App.",
  media_auto_download_unsupported: "Die Ordnerauswahl benötigt Chrome oder Edge",
  media_auto_download_continue: "Ordnerzugriff erlauben, um fortzufahren",
  media_export_server: "Medien-Exportserver",
  media_export_server_info: "Verbinde einen WebDAV- oder SFTP-Server. Jeder Chat und jedes Projekt kann dann jeden Abend um 20:00 neue Medien in einen eigenen Ordner exportieren.",
  media_export_protocol: "Protokoll",
  media_export_host: "Host",
  media_export_port: "Port",
  media_export_username: "Benutzername",
  media_export_password: "Passwort",
  media_export_base_path: "Basispfad (optional)",
  media_export_test: "Verbindung testen",
  media_export_test_ok: "Verbindung erfolgreich",
  media_export_test_fail: "Verbindung fehlgeschlagen",
  media_export_saved: "Verbindung gespeichert",
  media_export_disconnect: "Trennen",
  media_export_disconnect_confirm: "Diesen Dateiserver trennen?",
  media_export_folder: "Nächtlicher Medien-Export",
  media_export_folder_placeholder: "/Projekte/Alpha",
  media_export_nightly_hint: "Neue Bilder, Videos und Dokumente werden um 20:00 hochgeladen",
  media_export_nightly_info: "Neue Bilder, Videos und Dokumente werden jeden Abend um 20:00 in den Ordnerpfad auf dem Unternehmensserver hochgeladen. Die App muss nicht geöffnet sein.",
  media_export_admin_required: "Ein Dateiserver muss im Admin Panel verbunden werden.",
  media_export_readonly: "Wird nachts nach {path} exportiert",
  media_export_last_error: "Letzter Export fehlgeschlagen",
  change: "Ändern",
  add_employee_confirm: 'Möchtest du diesen Benutzer wirklich zur Firma hinzufügen?',
  invalid_deeplink: "Ungültiger Deeplink. Erforderliche Parameter fehlen.",
  deeplink_error: "Deeplink konnte nicht verarbeitet werden. Bitte versuche es später erneut.",
  reply: "Antworten",
  reply_enter: "Antwort eingeben…",
  reply_sent_successfully: "Antwort erfolgreich gesendet",
  reply_failed: "Antwort konnte nicht gesendet werden",
  reply_failed_generic: "Antwort konnte nicht gesendet werden. Bitte versuche es erneut.",
  replying_to_message: "Antwort auf Nachricht",
  cancel_reply: "Antwort abbrechen",
  voice_message: "Sprachnachricht",
  send: "Antworten",
  cancel: "Abbrechen",
  type_your_reply: "Antwort eingeben…",
  
  // Auto-suggestion translations
  suggested_replies: "Vorgeschlagene Antworten",
  suggestions_error: "Vorschläge konnten nicht geladen werden",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Bild — Klicken zum Laden",
  lazy_media_audio: "Sprachnachricht — Klicken zum Laden",
  lazy_media_doc: "Dokument — Klicken zum Laden",
  lazy_media_video: "Video — Klicken zum Laden",
  suggestion_loading_message: "Nur noch ein kurzer Moment. Dein Text wird individuell für dich vorbereitet.",
  loading_chat_message: "Lade Chat...",
  
  // Manual ToDo translations
  create_todo: "Aufgabe erstellen",
  create_todo_confirmation: "Möchtest du aus dieser Nachricht eine Aufgabe erstellen?",
  select_project_required: "Bitte wähle ein Projekt/eine Gruppe",
  only_assigned_can_change_status: "Nur zugewiesene Benutzer können den Status ändern",
  todo_summary: "Zusammenfassung",
  todo_summary_placeholder: "Zusammenfassung der Aufgabe eingeben...",
  todo_date: "Datum",
  todo_time: "Uhrzeit",
  deadline: "Frist",
  todo_date_hint: "Leer lassen, um das ursprüngliche Nachrichtendatum zu verwenden",
  todo_created_success: "Aufgabe erfolgreich erstellt",
  extracting_message: "Nachricht wird extrahiert...",
  creating_todo: "Aufgabe wird erstellt...",
  bookmark_todo_creating: "Vorgemerkte Aufgabe wird erstellt...",
  navigating_to_todo: "Weiterleitung zu Aufgaben...",
  todo_creation_failed: "Aufgabe konnte nicht erstellt werden",
  todo_created_from_message: "Aufgabe aus dieser Nachricht erstellt",
  create: "Erstellen",
  
  image: "Bild",
  images: "Bilder",
  remove_all_images: "Alle Bilder entfernen",
  remove_image: "Bild entfernen",
  remove_document: "Dokument entfernen",
  remove_recording: "Aufnahme entfernen",
  play_recording: "Aufnahme abspielen",
  upload_image: "Bild hochladen",
  upload_document: "Dokument hochladen",
  record_audio: "Audio aufnehmen",
  stop_recording: "Aufnahme stoppen",
  stop_recording_text: "Aufnahme stoppen",
  please_remove_current_attachment: "Bitte entferne den aktuellen Anhang, um",
  please_upload_image_file: "Bitte lade eine gültige Bilddatei hoch",
  please_upload_valid_document: "Bitte lade eine gültige Dokumentdatei hoch",
  searching_messages: "Nachrichten werden gesucht...",
  loading_more: "Weitere werden geladen...",
  loading_more_users: "Weitere Benutzer werden geladen...",
  load_more_users: "Weitere Benutzer laden",
  no_more_users_to_load: "Keine weiteren Benutzer zu laden",
  no_messages_found: "Keine Nachrichten gefunden",
  try_different_keyword: "Versuche ein anderes Schlüsselwort oder überprüfe die Schreibweise.",
  search_messages: "Nachrichten, Chats, Aufgaben, Projekte und Benutzer suchen..",
  search_messages_with_email: "Nachrichten, E-Mails, Chats, Aufgaben, Projekte und Benutzer suchen..",
  search_describe: "Beschreibe, wonach du suchst…",
  search_describe_with_email: "Beschreibe, wonach du suchst…",
  search_describe_examples: "z. B. Nachrichten von Martin über Rechnung · Benutzer Martin Langen · oder einfach ein Stichwort",
  search_describe_examples_with_email: "z. B. E-Mails von ml@bl2020.com mit Passwort · Nachrichten von Martin über Rechnung · Benutzer Martin Langen",
  search_intent_understood: "Suche",
  search_intent_emails: "E-Mails",
  search_intent_messages: "Nachrichten",
  search_intent_user: "Benutzer",
  search_submit: "Suchen",
  search_groups: "Gruppen",
  search_chat_groups: "Chats",
  search_project_room: "Projekt",
  search_messages_tab: "Nachrichten",
  search_result_kjuup_chat: "Nachrichten Kjuup Chat",
  search_users_tab: "Benutzer",
  search_documents_tab: "Dokumente",
  company_documents: "Firmendokumente",
  company_documents_empty: "Keine Dokumente vorhanden.",
  no_media_available: "Keine Dateien",
  no_documents_available: "Keine Dokumente",
  searching_groups: "Gruppen werden gesucht...",
  searching_rooms: "Projekte werden gesucht...",
  searching_users: "Benutzer werden gesucht...",
  no_groups_found: "Keine Gruppen gefunden",
  no_rooms_found: "Keine Projekte gefunden",
  no_users_found: "Keine Benutzer gefunden",
  search_emails_tab: "E-Mail",
  searching_emails: "E-Mails werden gesucht...",
  no_emails_found: "Keine E-Mails gefunden",
  search_email_addresses_tab: "E-Mail Adressen",
  search_email_content_tab: "E-Mail Inhalt",
  searching_email_content: "E-Mail-Inhalt wird gesucht...",
  no_email_content_found: "Kein E-Mail-Inhalt gefunden",
  search_email_attachments_tab: "E-Mail Anhänge",
  searching_email_attachments: "Anhänge werden gesucht...",
  no_email_attachments_found: "Keine Anhang-Treffer gefunden",
  email_attachments_label: "Anhänge",
  searching_email_addresses: "Adressen werden gesucht...",
  no_email_addresses_found: "Keine Adress-Treffer gefunden",
  search_email_filter_all: "Alle",
  search_email_filter_content: "Inhalt",
  search_email_filter_addresses: "Adressen",
  search_email_filter_attachments: "Anhänge",
  search_email_filter_has_attachments: "Mit Anhang",
  search_email_filter_unread: "Ungelesen",
  search_email_combo_placeholder: "In E-Mails von (optional)…",
  search_email_combo_content_placeholder: "In diesen E-Mails suchen…",
  search_email_combo_hint: "Suche in E-Mails von",
  search_email_combo_containing: "mit Inhalt",
  email_subject_label: "Betreff",
  email_body_label: "Text",
  email_address_received: "Empfangen",
  email_address_sent: "Gesendet",
  search_todos_tab: "Aufgaben",
  no_todos_found: "Keine Aufgaben gefunden",
  todo: "Aufgabe",
  np_todo: "Keine Aufgaben",
  move_to_todo: "Als Aufgabe speichern",
  remove_todo: "Willst du die Aufgabe wirklich entfernen?",
  remove_all_todo: "Alle Aufgaben entfernen",
  remove_all_todo_confirm: "Willst du wirklich alle Aufgaben entfernen?",
  add_to_todo: "Zu Aufgaben hinzufügen",
  remove_from_todo: "Von Aufgaben entfernen",
  confirm: "Bestätigen",
  ok: "Ok",
  cancel: "Abbrechen",
  read_more: "Mehr lesen",
  show_less: "Weniger anzeigen",
  show_more: "Mehr anzeigen",
  audio: "Audio",
  video: "Video",
  // Notification Settings
  browser_notifications: "Desktop-Benachrichtigungen",
  browser_notifications_desc: "Lassen Sie sich über neue Nachrichten benachrichtigen, auch wenn Kjuup im Hintergrund ist.",
  browser_notifications_blocked: "Benachrichtigungen sind in Ihrem Browser blockiert. Erlauben Sie sie für diese Seite in der Adressleiste und versuchen Sie es erneut.",
  browser_notifications_unsupported: "Desktop-Benachrichtigungen werden in diesem Browser nicht unterstützt.",
  browser_notifications_error: "Desktop-Benachrichtigungen konnten nicht aktualisiert werden",
  notification_schedule: "Benachrichtigungsplan",
  notification_schedule_desc: "Sie erhalten Push- und E-Mail-Benachrichtigungen nur in den von Ihnen gewählten Stunden. Außerhalb dieser Zeiten werden sie pausiert.",
  company_notification_schedule_desc: "Lege die Benachrichtigungszeiten für alle Firmenmitglieder fest. Dadurch werden die persönlichen Benachrichtigungseinstellungen aller Mitglieder überschrieben.",
  learn_more: "Mehr erfahren",
  allow_notifications: "Benachrichtigungen erlauben:",
  every_day: "Jeden Tag",
  weekdays: "Wochentage (Montag bis Freitag)",
  custom: "Benutzerdefiniert",
  monday: "Montag",
  tuesday: "Dienstag",
  wednesday: "Mittwoch",
  thursday: "Donnerstag",
  friday: "Freitag",
  saturday: "Samstag",
  sunday: "Sonntag",
  to: "bis",
  notification_settings: "Benachrichtigungen",
  notification_settings_saved: "Benachrichtigungseinstellungen erfolgreich gespeichert",
  notification_settings_error: "Fehler beim Speichern der Benachrichtigungseinstellungen",
  unavailability_note: "Abwesenheitsnotiz",
  unavailability_description: "Legen Sie eine Abwesenheitsnotiz fest. Solange aktiv, wird die Notiz in allen Ihren Chats angezeigt und Benachrichtigungen werden pausiert.",
  unavailability_start_date: "Startdatum",
  unavailability_end_date: "Enddatum",
  unavailability_message: "Nachricht",
  unavailability_message_hint: "Verwenden Sie {endDate} als Platzhalter für Ihr Rückkehrdatum.",
  unavailability_replacement: "Vertretung",
  unavailability_replacement_placeholder: "Benutzer-ID für dringende Anfragen eingeben",
  unavailability_replacement_current: "Aktuelle Vertretung",
  unavailability_replacement_hint: "Falls gesetzt, wird ein Link angezeigt, um diese Person bei dringenden Angelegenheiten zu kontaktieren.",
  unavailability_replacement_none: "Keine Vertretung (optional)",
  unavailability_contact_urgent: "Für dringende Anfragen kontaktieren Sie",
  unavailability_default_message: "Ich bin derzeit nicht im Büro und habe keinen Zugriff auf Kjuup. Ab dem {endDate} bin ich wieder erreichbar und melde mich dann bei Ihnen.",
  unavailability_save: "Speichern",
  unavailability_deactivate: "Deaktivieren",
  unavailability_active_until: "Aktiv bis",
  unavailability_saved: "Abwesenheitsnotiz gespeichert",
  unavailability_save_error: "Fehler beim Speichern der Abwesenheitsnotiz",
  unavailability_deactivated: "Abwesenheitsnotiz deaktiviert",
  unavailability_end_date_required: "Enddatum ist erforderlich",
  start_time_before_end_time: "Startzeit muss vor Endzeit liegen",
  loading: "Laden",
  disabled: "Deaktiviert",
  enable: "Aktivieren",
  disable: "Deaktivieren",
  forwarded: "Weitergeleitet",
  message_forwarded: "Nachricht weitergeleitet!",
  // Schedule Article
  schedule_article_post: "Termin für Beitrag festlegen",
  date: "Datum",
  time: "Uhrzeit",
  scheduled_for_publication: "Zur Veröffentlichung geplant",
  scheduled_and_drafts: "Geplante Artikel und Entwürfe",
  article_scheduled: "Geplant",
  article_draft: "Entwurf",
  article_drafts: "Entwürfe",
  no_scheduled_or_drafts: "Keine geplanten Artikel oder Entwürfe",
  no_scheduled_articles: "Keine geplanten Artikel",
  no_draft_articles: "Keine Entwürfe",
  save_as_draft: "Als Entwurf speichern",
  article_will_be_published_on: "Artikel wird veröffentlicht am:",
  reset_selection: "Auswahl zurücksetzen",
  continue: "Weiter",
  cancel: "Abbrechen",
  // Member Selection
  error_loading_members: "Fehler beim Laden der Mitglieder",
  please_fill_all_fields: "Bitte fülle alle Felder aus",
  invalid_email: "Ungültige E-Mail-Adresse",
  member_added_successfully: "Mitglied erfolgreich hinzugefügt",
  error_onboarding_user: "Fehler beim Hinzufügen des Benutzers",
  error_creating_chat: "Fehler beim Erstellen des Chats",
  error_creating_group: "Fehler beim Erstellen der Gruppe",
  new_group: "Neue Gruppe",
  please_select_or_enter_group_name: "Bitte wähle eine Gruppe aus oder gib einen Gruppennamen ein",
  please_select_or_enter_room_name: "Bitte wähle ein Projekt aus oder gib einen Projektnamen ein",
  error_creating_room: "Fehler beim Erstellen des Projekts",
  error_opening_chat: "Fehler beim Öffnen des Chats",
  privacy_modal_text: "Wähle privat nur, wenn er Chat keine relevanten fachlichen Inhalte für Projektleiter enthält.",
  not_private: "Nicht privat",
  private: "Privat",
  error_loading_groups: "Fehler beim Laden der Gruppen",
  automatic_chat_export: "Automatischer Chat Export",
  automatic_chat_export_info: "Nach Aktivierung erhältst du die Chat-Historie monatlich automatisch an die angegebene E-Mail-Adresse.",
  automatic_chat_export_no_email: "Um den automatischen Chat-Export zu aktivieren, musst du zuerst eine E-Mail-Adresse hinterlegen. Du kannst deine E-Mail-Adresse in den persönlichen Einstellungen ergänzen.",
  enter_email: "E-Mail eingeben",
  update: "Aktualisieren",
  confirm: "Bestätigen",
  export_to_email: "Der Export erfolgt an folgende E-Mail.",
  matching_existing_chats: "Passende bestehende Chats",
  subject: "Betreff",
  add_subject: "Betreff hinzufügen",
  chat_subject: "Chat Betreff:",
  set_project_room: "Projekt festlegen",
  matching_existing_project_rooms: "Passende bestehende Projekte",
  name_project_room: "Projektname",
  professional_or_private: "Beruflich oder privat",
  professional: "Beruflich",
  privacy_modal_text_updated: "Wähle \"Privat\" nur, wenn der Chat keine relevanten fachlichen Inhalte für Projektleiter enthält. Private Chats sind für Projektleiter nicht einsehbar.",
  create_internal_chat: "Externer - oder interner Chat?",
  internal_chat_description: "Zu internen Chats können ausschließlich eigene Mitarbeitende hinzugefügt werden.",
  yes: "Ja",
  no: "Nein",
  chat_is_being_created: "Chat wird erstellt...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Willst du die Änderungen an diesem Artikel wirklich verwerfen?",
  save_article_as_draft_confirm: "Möchtest du diesen Artikel als Entwurf speichern?",
  please_enter_article_title: "Bitte gib zuerst einen Artikeltitel ein.",
  please_add_mandatory_fields: "Bitte alle Pflichtfelder ausfüllen",
  product_label: "Produkt:",
  no_companies_found: "Keine Firmen gefunden",
  visible_to_all_followers: "Sichtbar für alle Kjuup Mitglieder",
  only_visible_to_employees: "Nur für Mitarbeiter sichtbar",
  something_went_wrong: "Etwas ist schief gelaufen, bitte versuche es erneut",
  please_select_department: "Bitte Abteilung/Standort auswählen",
  schedule: "Planen",
  please_select_future_date_time: "Bitte wähle ein zukünftiges Datum und eine zukünftige Uhrzeit für die Planung des Artikels.",
  please_select_different_date_time: "Bitte wähle ein anderes Datum oder eine andere Uhrzeit.",
  please_select_later_time: "Bitte wähle eine Uhrzeit nach der aktuellen Zeit für heute.",
  unpin_article: "Artikel lösen",
  pin_article: "Artikel anpinnen",
  and: "und",
  others: "andere",
  at: "um",
  company_article: "Firmenartikel",
  // Chat mute/unmute translations
  mute: "Stummschalten",
  unmute: "Stummschaltung aufheben",
  chat_muted_successfully: "Chat erfolgreich stummgeschaltet",
  chat_unmuted_successfully: "Stummschaltung des Chats aufgehoben",
  mute_chat_confirm: "Möchtest du diesen Chat wirklich stummschalten? Du erhältst keine Benachrichtigungen mehr für neue Nachrichten.",
  unmute_chat_confirm: "Möchtest du die Stummschaltung dieses Chats wirklich aufheben? Du erhältst wieder Benachrichtigungen für neue Nachrichten.",
  please_select_group_to_forward: "Bitte Gruppe zum Weiterleiten auswählen",
  // Company translations
  record_not_found: "Kein Datensatz gefunden!",
  please_select_position: "Bitte Position auswählen",
  delete_article_confirm: "Bist du sicher, dass du diesen Artikel löschen willst?",
  delete_company_service_confirm: "Bist du sicher, dass du die Firmenleistung löschen möchtest?",
  block_translation_confirm: "Willst du die automatische Übersetzungsfunktion in Projekten für Mitglieder der Firma blockieren",
  unblock_translation_confirm: "Willst du die automatische Übersetzungsfunktion in Projekten für Mitglieder der Firma erlauben",
  please_select_file: "Bitte wähle eine Datei zum Hochladen aus",
  role_in_building_industry: "Rolle in der Baubranche*",
  invalid_email_address: "Ungültige E-Mail-Adresse",
  please_enter_password: "Bitte gib ein Passwort ein",
  password_change_email_sent: "Eine E-Mail wurde an deine Kjuup-E-Mail-Adresse gesendet. Bitte bestätige dein neues Passwort, indem du auf den Bestätigungslink in der E-Mail klickst.",
  please_enter_username: "Bitte gib einen Benutzernamen ein",
  username_same_as_before: "Der Benutzername darf nicht mit dem vorherigen übereinstimmen",
  profile_deleted_successfully: "Profil erfolgreich gelöscht",
  hardware_requirements: "Hardware Anforderungen",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU Geschwindigkeit min. 2GHz<br/>• Windows 7 oder höher / alle Varianten macOS",
  submitting: "Wird gesendet...",
  signing_in: "Anmeldung läuft...",
  please_enter_service_name: "Bitte gib einen Servicenamen ein",
  something_went_wrong_error: "Aaaah! Etwas ist schief gelaufen...",
  something_went_wrong_try_again: "Entschuldigung, da ist etwas schief gelaufen. Versuche es erneut",
  position_label: "Position:",
  loading_room: "Projekt wird geladen...",
  navigating_to_room: "Zum Projekt navigieren",
  loading_chat: "Chat wird geladen...",
  translate: "Übersetzen",
  show_original: "Original anzeigen",
  show_translation: "Übersetzung anzeigen",
  click_to_show_original: "Klicken, um Original anzuzeigen",
  click_to_show_translation: "Klicken, um Übersetzung anzuzeigen",
  saving: "Speichern...",
  language_selection_info: "Die Sprachauswahl wird für alle E-Mail Bestätigungen, die die Firma betreffen, verwendet.",
  video_call: "Videoanruf",
  audio_call: "Audioanruf",
  // Navigation bar labels
  nav_call: "Anruf",
  nav_home: "Home",
  nav_messages: "Nachrichten",
  nav_todo: "Aufgaben",
  nav_rooms: "Projekte",
  nav_all_rooms: "Alle Projekte",
  pinned_rooms_max: "Du kannst maximal 10 Projekte anheften.",
  pinned_room_unpin: "Lösen",
  pinned_rooms_drop: "Projekt hierher ziehen",
  nav_profile: "Profileinstellungen",
  nav_company: "Firmen",
  nav_company_documents: "Firmendokumente",
  nav_logout: "Abmelden",
  // Create message dialog
  add_member_title: "Mitglied hinzufügen",
  continue_btn: "Weiter",
  search_placeholder: "Suche",
  no_members_found: "Keine Mitglieder gefunden",
  no_groups_found: "Keine Gruppen gefunden",
  no_rooms_found: "Keine Projekte gefunden",
  unnamed_group: "Unbenannte Gruppe",
  unnamed_room: "Unbenanntes Projekt",
  all_members: "Alle",
  room_label: "Projekt:",
  subject_label: "Betreff:",
  no_members: "Keine Mitglieder",
  // Loading states for room creation
  creating_structure: "Struktur wird erstellt",
  opening_chat: "Chat wird geöffnet",
  please_wait: "Bitte warten...",
  // Loading states for company join
  sending_request: "Anfrage wird gesendet",
  updating_profile: "Profil wird aktualisiert",
  // ToDo page translations
  loading_todo: "Aufgabe wird geladen...",
  task_updated: "Aufgabe aktualisiert",
  error_updating_task: "Fehler beim Aktualisieren",
  task_deleted: "Aufgabe gelöscht",
  error_deleting_task: "Fehler beim Löschen",
  delete_task_confirm: "Möchtest du diese Aufgabe wirklich löschen?",
  delete_bookmarked_priority_confirm: "Möchtest du diese vorgemerkte Aufgabe wirklich löschen?",
  delete_multiple_tasks_confirm: "Möchtest du wirklich {count} Aufgaben löschen?",
  delete_selected_count: "Löschen ({count})",
  todo_multi_delete: "Mehrere löschen",
  todo_multi_delete_hint: "Aufgaben zum Löschen auswählen",
  todos_deleted_count: "{count} Aufgaben gelöscht",
  pro_todo_delete_previous: "Alle löschen",
  pro_todo_previous_title: "{{n}} überfällige Aufgaben löschen?",
  pro_todo_previous_text: "Alle deine offenen Aufgaben der vergangenen Tage werden gelöscht.",
  pro_todo_previous_skipped: "{{n}} von anderen zugewiesene bleiben.",
  pro_todo_previous_none: "Keine überfälligen Aufgaben",
  pro_todo_previous_none_own: "Die überfälligen Aufgaben wurden dir von anderen zugewiesen und können nur von ihnen gelöscht werden.",
  todos_deleted_partial: "{ok} Aufgaben gelöscht, {fail} fehlgeschlagen",
  delete_only_own: "Du kannst nur Aufgaben löschen, die du selbst erstellt hast",
  description_label: "Beschreibung",
  description_placeholder: "Beschreibung eingeben...",
  date_time_label: "Datum & Uhrzeit",
  save_hint: "Strg+Enter zum Speichern, Esc zum Abbrechen",
  edit_label: "Bearbeiten",
  delete_label: "Löschen",
  todo_list_title: "Aufgaben",
  tasks_count: "Aufgaben",
  search_placeholder_todo: "Suchen...",
  select_task_to_open_chat: "Wähle eine Aufgabe aus, um den Chat zu öffnen",
  today: "Heute",
  yesterday: "Gestern",
  time_suffix: " Uhr", // German time suffix
  from_chat: "Quelle Aufgabe",
  assigned_to: "Zugewiesen an",
  assign_users: "Benutzer zuweisen",
  assigned_users: "Zugewiesene Benutzer:",
  no_users_assigned: "Keine Benutzer zugewiesen",
  assign: "Zuweisen",
  assign_to: "Zuweisen an...",
  navigate_to_chat: "Zum Chat navigieren",
  navigate_to_email: "Zur E-Mail navigieren",
  navigate_to_source: "Zur Quelle navigieren",
  show_original_message: "Quelle anzeigen",
  hide_original_message: "Quelle ausblenden",
  status_pending: "Ausstehend",
  status_in_progress: "In Bearbeitung",
  status_completed: "Abgeschlossen",
  show: "Anzeigen",
  close: "Schließen",
  // Additional ToDo translations
  todo_beta: "BETA",
  todo_project_label: "Projektzuordnung:",
  todo_room_none: "Keine Zuordnung",
  todo_room_clear: "Projektzuordnung entfernen",
  todo_chat_label: "Chat:",
  todo_assigned_by: "Zugewiesen von:",
  todo_assigned_push: "Aufgabe zugewiesen:",
  todo_assigned_push_empty: "Dir wurde eine neue Aufgabe zugewiesen.",
  todo_clear_all: "Alle löschen",
  todo_unknown: "Unbekannt",
  filter_all: "Alle",
  filter_assigned_to_me: "Meine Aufgaben",
  filter_assigned_by_me: "Delegiert",
  completed_by: "Abgeschlossen von:",
  verify_completion: "Bestätigen",
  back_into_in_progress: "Zurück in Bearbeitung",
  unassign_todo: "Zuweisung aufheben",
  unassign_label: "Entfernen",
  me: "Ich",
  search_or_select_project: "Projekt suchen oder auswählen...",
  // Confirmed ToDo and History translations
  status_confirmed: "Bestätigt",
  todo_confirmed: "Aufgabe bestätigt",
  history: "Verlauf",
  marked_as: "Markiert als",
  at_date: "am",
  at_time: "um",
  time_suffix: "Uhr",
  all_todos: "Offene Aufgaben",
  confirmed_todos: "Bestätigte Aufgaben",
  filter_pending: "Ausstehend",
  filter_confirmed: "Bestätigt",
  my_list: "Mein Tag",
  todo_adjust_list: "Liste anpassen",
  apply: "Anwenden",
  move_back_in_progress: "Zurück in Bearbeitung",
  no_history_yet: "Noch kein Verlauf",
  todo_status_updated: "Aufgabenstatus von {from} auf {to} aktualisiert",
  todo_status_updated_from: "von",
  todo_status_updated_to: "auf",
  // Log description translations
  log_todo_created: "Aufgabe erstellt",
  log_todo_confirmed: "Aufgabe bestätigt",
  log_todo_deleted: "Aufgabe gelöscht",
  log_todo_updated: "Aufgabe aktualisiert",
  log_description_updated: "Beschreibung aktualisiert",
  log_deadline_updated: "Frist aktualisiert",
  log_assigned_to: "Zugewiesen an {name}",
  log_unassigned_from: "Zuweisung entfernt von {name}",
  log_assignment_added: "Zuweisung hinzugefügt: {name}",
  log_assignment_removed: "Zuweisung entfernt: {name}",
  log_status_updated: "Status geändert von {from} auf {to}",
  log_status_changed: "Status geändert",
  log_status_changed_to: "Status geändert auf {status}",
  log_changed_status_to: "Status geändert auf:",
  log_for_user: "für Benutzer:",
  log_user_updated_status: "Benutzer hat den Aufgabenstatus aktualisiert",
  log_changed_date_to: "Datum geändert auf:",
  log_changed_description_to: "Beschreibung geändert auf:",
  log_moved_to: "Verschoben nach {status}",
  // ToDo filter translations
  todo_filters: "Filter",
  todo_filter_by_project: "Nach Projekt filtern",
  todo_status: "Status",
  todo_assignment: "Zuweisung",
  todo_filter_by_user: "Nach zugewiesener Person filtern",
  todo_active_filters: "Aktive Filter:",
  todo_progress: "Fortschritt",
  todo_my_list_empty: "Dein Tag ist leer",
  todo_my_list_empty_hint: "Klicke auf „Liste anpassen“, um Aufgaben hinzuzufügen",
  create_poll: "Umfrage",
  poll_question_label: "FRAGE",
  poll_question_placeholder: "Frage stellen",
  poll_options_label: "OPTIONEN",
  poll_option: "Option",
  poll_add_option: "Option hinzufügen",
  poll_allow_multiple: "Mehrere Antworten erlauben",
  poll_multiple_allowed: "Eine oder mehrere Optionen auswählen",
  poll_select_option: "Eine Option auswählen",
  poll_view_votes: "Abstimmung ansehen",
  poll_vote_singular: "Stimme",
  poll_vote_plural: "Stimmen",
  poll_votes: "Abstimmungsergebnis",
  poll_no_votes_yet: "Noch keine Stimmen",
  transcript_label: "Transkription",
  ai_generated_transcription: "KI-generierte Transkription",
  transcript_start: "Sprachnachricht transkribieren",
  transcript_transcribing: "Transkribierung...",
  transcript_show: "Transkription anzeigen",
  transcript_hide: "Transkription ausblenden",
  transcript_redo: "Transkription wiederholen",
  transcript_failed: "Transkription fehlgeschlagen",
  transcript_no_result: "Kein Transkript erhalten",
  transcript_step_listening: "Sprachnachricht wird angehört...",
  transcript_step_processing: "Transkription läuft...",
  transcript_step_creating: "Text wird erstellt...",
  ai_transcript_tab: "AI-Transkript",
  ai_transcript_info: "Nur verfügbar für Sprachnachrichten, die nach dem 09.03.2026 erstellt wurden.",
  no_transcript_available: "Kein Transkript verfügbar.",
  transcript_more: "...mehr",
  transcript_less: "...weniger",
  ki_transcript_voice_message: "KI-Transkript der Sprachnachricht",
  ki_image_analysis: "KI-gestützte Bildanalyse",
  document_analysis: "Dokumentenanalyse",
  type_message: "Nachricht eingeben",
  email_tab_messages: "Nachrichten",
  email_tab_email: "E-Mail",
  email_tab_messages_and_email: "Nachrichten & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "E-Mail-Konten",
  calendar_sync_title: "Kalender-Sync",
  calendar_sync_info: 'Synchronisiere automatisch alle Kjuup-Aufgaben mit deinem Kalender.',
  calendar_connect_google: "Google Kalender verbinden",
  calendar_connect_outlook: "Outlook Kalender verbinden",
  calendar_connect_apple_caldav: "Apple / CalDAV verbinden",
  calendar_connect: "Verbinden",
  calendar_connected: "Kalender verbunden",
  calendar_connect_failed: "Kalenderverbindung fehlgeschlagen",
  calendar_disconnected: "Kalender getrennt",
  calendar_disconnect_confirm: "Diesen Kalender trennen? Bestehende Termine bleiben erhalten; die Synchronisation wird gestoppt.",
  calendar_no_accounts: 'Noch kein Kalender verbunden.',
  calendar_sync_enabled: "Sync aktiv",
  calendar_on_complete: "Wenn Aufgabe erledigt ist",
  calendar_on_complete_delete: "Kalendereintrag entfernen",
  calendar_on_complete_mark: "Eintrag als erledigt markieren",
  calendar_target: "Zielkalender",
  calendar_refresh_list: "Aktualisieren",
  calendar_auth_error: "Erneut verbinden erforderlich",
  calendar_apple_hint: "Nutzen Sie Ihre Apple-ID-E-Mail und ein app-spezifisches Passwort von appleid.apple.com.",
  calendar_server_url: "CalDAV-Server-URL",
  calendar_username: "Benutzername / E-Mail",
  calendar_password: "Passwort / App-Passwort",
  calendar_caldav_required: "Benutzername und Passwort sind erforderlich.",
  calendar_caldav_server_required: "Server-URL ist für CalDAV erforderlich.",
  calendar_auth_url_failed: "Autorisierungs-URL konnte nicht geladen werden.",
  calendar_syncing: "Kalender wird aktualisiert…",
  calendar_sync_up_to_date: "Kalender ist aktuell",
  calendar_sync_failed: "Synchronisierung fehlgeschlagen",
  calendar_sync_complete: "Kalender aktualisiert",
  calendar_sync_now: "Jetzt synchronisieren",
  calendar_reconnect: "Erneut verbinden",
  email_connect_gmail: "Gmail verbinden",
  email_connect_outlook: "Outlook verbinden",
  email_no_accounts: "Keine E-Mail-Konten verbunden",
  email_no_accounts_hint: "Verbinde ein E-Mail-Konto in deinen Profileinstellungen",
  email_no_messages: "Keine E-Mails",
  email_from: "Von",
  email_to: "An",
  email_subject: "Betreff",
  email_disconnect: "Trennen",
  email_disconnect_confirm: "Bist du sicher, dass du dieses E-Mail-Konto trennen möchtest? Alle synchronisierten E-Mails werden entfernt.",
  email_account_disconnected: "E-Mail-Konto erfolgreich getrennt",
  email_account_disconnect_failed: "E-Mail-Konto konnte nicht getrennt werden",
  email_connecting: "Verbinde...",
  email_account_connected: "Konto erfolgreich verbunden",
  email_connection_error: "Verbindungsproblem",
  email_connection_error_hint: "Dieses Konto konnte nicht synchronisiert werden. Bitte erneut verbinden, damit neue E-Mails wieder ankommen.",
  email_reconnect: "Erneut verbinden",
  email_edit_settings: "Einstellungen anpassen",
  email_imap_edit_title: "IMAP-Konto bearbeiten",
  email_imap_edit_hint: "E-Mail-Adresse oder Passwort aktualisieren und speichern, um das Konto erneut zu verbinden.",
  email_imap_save: "Speichern & verbinden",
  email_reconnect_banner: "Ein oder mehrere E-Mail-Konten müssen erneut verbunden werden.",
  email_reconnect_manage: "In Einstellungen beheben",
  email_connection_warning: "Die E-Mail-Verbindung für {email} funktioniert nicht mehr richtig. Bitte erneut verbinden, damit neue E-Mails ankommen.",
  email_connection_warning_multi: "Die E-Mail-Verbindungen für {emails} funktionieren nicht mehr richtig. Bitte erneut verbinden, damit neue E-Mails ankommen.",
  email_connected_accounts: "Verbundene Konten",
  email_sync_info: "Beim Verbinden eines E-Mail-Kontos werden standardmäßig die E-Mails des letzten Monats synchronisiert. Sie können den Synchronisierungszeitraum unten erweitern.",
  email_sync_3_months: "Letzte 3 Monate sync.",
  email_sync_6_months: "Letzte 6 Monate sync.",
  email_syncing: "Synchronisiere...",
  email_sync_already_done: "{months} Monate bereits synchronisiert",
  email_sync_more: "Weitere Monate synchronisieren",
  email_sync_retry: "Monate erneut synchronisieren",
  email_sync_all_done: "Alle Monate synchronisiert",
  email_sync_backfill_started: "Ältere E-Mails werden nachgeladen — bei großen Postfächern kann das einige Minuten dauern…",
  email_sync_backfill_hint: "Fehlende ältere E-Mails in diesem Zeitraum nachladen",
  email_sync_retry_3_months: "Letzte 3 Monate erneut sync.",
  email_sync_retry_6_months: "Letzte 6 Monate erneut sync.",
  email_syncing_account: "Konto wird synchronisiert, dies kann einige Minuten dauern…",
  email_signature: "Signatur",
  email_signature_placeholder: "Geben Sie Ihre E-Mail-Signatur ein...",
  email_signature_save: "Speichern",
  email_signature_saved: "Gespeichert",
  email_add_account: "Konto hinzufügen",
  email_folder_inbox: "Posteingang",
  email_folder_spam: "Spam",
  email_folder_drafts: "Entwürfe",
  email_folder_sent: "Gesendete Elemente",
  email_folder_deleted: "Gelöschte Elemente",
  email_folder_archive: "Archiv",
  email_folder_outbox: "Postausgang",
  email_custom_folders: "Ordner",
  email_create_folder: "Neuer Ordner",
  email_delete_folder: "Ordner löschen",
  email_folder_name_placeholder: "Ordnername",
  email_folder_created: "Ordner erstellt",
  email_folder_deleted: "Gelöschte Elemente",
  email_move_to: "Verschieben nach",
  email_moved_to_folder: "In Ordner verschoben",
  email_move_to_inbox: "In Posteingang verschieben",
  email_confirm_delete_folder: "Möchten Sie diesen Ordner wirklich löschen?",
  email_refresh: "Aktualisieren",
  email_folder_not_synced: "Dieser Ordner wird nicht automatisch synchronisiert.",
  email_sync_folder: "Jetzt synchronisieren",
  email_go_to_settings: "Zu den Einstellungen",
  email_date: "Datum",
  email_reply: "Antworten",
  email_forward: "Weiterleiten",
  email_copy_text: "Text kopieren",
  email_more_actions: "Weitere Aktionen",
  email_text_copied: "Kopiert!",
  email_text_copy_failed: "Text konnte nicht kopiert werden.",
  email_delete: "Löschen",
  email_not_spam: "Kein Spam",
  email_not_spam_success: "E-Mail in den Posteingang verschoben.",
  email_not_spam_failed: "Verschieben in den Posteingang fehlgeschlagen.",
  email_delete_confirm: "Sind Sie sicher, dass Sie diese E-Mail löschen möchten?",
  email_delete_from_folder: "Möchten Sie wirklich aus {folder} löschen?",
  email_delete_permanent_from_folder:
    "Möchten Sie wirklich endgültig aus {folder} löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  email_save_draft_confirm: "Möchten Sie diese E-Mail als Entwurf speichern?",
  email_save_draft: "Entwurf speichern",
  email_discard: "Verwerfen",
  email_back_to_compose: "Zurück zum Schreiben",
  email_draft_saved: "Entwurf gespeichert.",
  email_saving_draft: "Entwurf wird gespeichert...",
  email_draft_save_failed: "Entwurf konnte nicht gespeichert werden.",
  email_loading: "E-Mails werden geladen...",
  email_imap_title: "IMAP",
  email_imap_hint: "Verbinde ein beliebiges E-Mail-Konto per IMAP.",
  email_imap_user: "E-Mail",
  email_imap_password: "Passwort",
  email_imap_connect_btn: "IMAP-Konto verbinden",
  email_imap_required: "Bitte E-Mail und Passwort eingeben.",
  email_imap_failed: "IMAP-Verbindung fehlgeschlagen.",
  email_imap_manual_toggle: "Manuelle Servereinstellungen",
  email_imap_host: "IMAP-Server (z.B. imap.ionos.de)",
  email_imap_port: "Port",
  email_imap_incoming: "Posteingang (IMAP)",
  email_smtp_outgoing: "Postausgang (SMTP)",
  email_smtp_host: "SMTP-Server (z.B. smtp.ionos.de)",
  email_smtp_port: "Port",
  email_send_btn: "Senden",
  email_sent: "E-Mail gesendet.",
  email_sending: "E-Mail wird gesendet...",
  deleting_emails: "E-Mail wird gelöscht...",
  marking_unread: "Als ungelesen markieren...",
  email_send_failed: "E-Mail konnte nicht gesendet werden.",
  email_compose_to_required: "Empfänger (An) ist erforderlich.",
  email_compose_body_required: "Bitte Betreff oder Nachricht eingeben.",
  email_compose_placeholder: "Nachricht schreiben...",
  email_original_message: "Originalnachricht",
  email_forwarded_message: "Weitergeleitete Nachricht",
  email_archived: "Archiviert",
  email_mark_spam: "Als Spam markieren",
  email_marked_spam: "Als Spam markiert",
  email_group_today: "Heute",
  email_group_yesterday: "Gestern",
  email_group_this_week: "Diese Woche",
  email_group_earlier: "Älter",
  email_search: "Suchen",
  email_search_placeholder: "In diesem Ordner suchen",
  email_no_results: "Keine passenden Nachrichten",
  email_clear_search: "Suche zurücksetzen",
  email_star: "Markieren",
  email_unstar: "Markierung entfernen",
  email_starred: "Markiert",
  email_folder_starred: "Markiert",
  email_select: "Auswählen",
  email_attachment_singular: "Anhang",
  email_attachment_plural: "Anhänge",
  email_back: "Zurück",
  email_download: "Herunterladen",
  email_download_all: "Alle herunterladen",
  email_download_all_zip: "Alle als ZIP herunterladen",
  email_download_failed: "Download fehlgeschlagen",
  email_close: "Schließen",
  email_preview: "Vorschau",
  email_preview_not_available: "Vorschau nicht verfügbar",
  email_preview_failed: "Vorschau nicht verfügbar",
  email_loading_preview: "Vorschau wird geladen...",
  email_no_subject: "(Kein Betreff)",
  email_mark_unread_failed: "E-Mail(s) konnten nicht als ungelesen markiert werden.",
  email_delete_failed: "E-Mail(s) konnten nicht gelöscht werden.",
  // E-Mail-zu-Raum-Klassifizierung
  email_classify_banner: "{count} E-Mail(s) von neuen Absendern müssen klassifiziert werden",
  email_classify_banner_inline: "{count} E-Mail(s) von neuen Absendern — unten jeweils einem Projekt zuordnen oder als Spam markieren",
  email_marked_spam: "In Spam verschoben",
  email_classify_review: "Prüfen",
  email_classify_title: "Absender zuordnen",
  email_classify_question_project: "Soll diese E-Mail einem Projekt zugeordnet werden?",
  email_project_name: "Projektname",
  email_classify_suggested: "Vorschlag",
  email_remember_sender: "Diesen Absender für zukünftige E-Mails merken",
  email_account_default_project: "E-Mails dieses Kontos immer diesem Projekt zuordnen",
  email_classify_associate: "Projekt zuordnen",
  email_associating_to_project: "E-Mail wird dem Projekt zugeordnet...",
  email_associating_spam: "Wird in Spam verschoben...",
  email_finding_similar: "Ähnliche E-Mails werden gesucht...",
  email_associating_similar: "Ähnliche E-Mails werden zugeordnet...",
  email_classify_missing: "Nicht zugeordnet",
  email_tag_daily_briefing: "Tagesbericht",
  email_project_navigate: "Zum Projekt wechseln",
  email_project_change: "Projektzuordnung ändern",
  email_project_remove: "Projektzuordnung entfernen",
  email_project_removed: "Projektzuordnung entfernt",
  email_classify_question_spam: "Ist dies SPAM oder Werbung?",
  email_classify_mark_spam: "In Spam verschieben",
  email_classify_skip: "Vorerst überspringen",
  email_classify_need_project: "Bitte einen Projektnamen eingeben",
  email_classify_refile_question: "Soll ich die E-Mail wieder im Projekt '{name}' ablegen?",
  email_classify_refile_yes: "Ja, in '{name}' ablegen",
  email_classify_save_question: "Soll ich die E-Mail im Projekt '{name}' abspeichern?",
  email_classify_save_yes: "Ja, im Projekt '{name}' speichern",
  email_saved_to_project: "E-Mail im Projekt gespeichert",
  email_saved_to_project_similar: "E-Mail im Projekt gespeichert. {count} ähnliche E-Mails wurden ebenfalls zugeordnet.",
  email_in_project: "Im Projekt",
  email_classify_choose_other: "Anderes Projekt wählen",
  email_new_room_title: "Neues Projekt erstellen",
  email_new_room_name: "Projektname",
  email_new_room_type: "Projekttyp",
  email_new_room_external: "Extern",
  email_new_room_internal: "Intern",
  email_new_room_company: "Firmenverbindung auswählen",
  email_new_room_company_info: "Wähle die Firmenverbindung aus, mit der du im Projekt aufgeführt werden willst. Diese wird anderen Mitgliedern angezeigt.",
  email_new_room_kjuup_company: "Kjuup+ Firma auswählen",
  email_new_room_kjuup_company_info: "Das interne Projekt gehört zu dieser Kjuup+ Firma.",
  email_new_room_internal_unavailable: "Tritt einer Kjuup+ Firma bei, um interne Projekte zu erstellen",
  email_new_room_create: "Projekt erstellen & E-Mail speichern",
  email_room_tab: "E-Mail",
  email_room_tab_all: "Alles",
  email_room_tab_todos: "Aufgaben",
  email_room_tab_briefings: "Tagesbericht",
  email_room_all_empty: "Noch keine Nachrichten in diesem Projekt",
  email_room_briefings_empty: "Keine Tagesberichte in diesem Projekt",
  email_room_empty: "Noch keine E-Mails in diesem Projekt",
  email_room_sent_empty: "Noch keine gesendeten E-Mails in diesem Projekt",
  email_room_drafts_empty: "Noch keine Entwürfe in diesem Projekt",
  email_room_inbox: "Posteingang",
  email_room_sent: "Gesendet",
  email_room_drafts: "Entwürfe",
  email_room_remove: "Aus Projekt entfernen",
  email_room_remove_confirm: "Diese E-Mail aus dem Projekt entfernen?",
  email_room_briefing_remove_confirm: "Willst du den Tagesbericht wirklich entfernen?",
  email_room_removed: "E-Mail aus Projekt entfernt",
  email_room_briefing_removed: "Tagesbericht entfernt",
  email_compose_project: "Projektzuordnung in Kjuup",
  email_compose_project_info:
    "Diese Information ist nur für dich sichtbar und wird nicht mit der E-Mail versendet.",
  email_compose_project_placeholder: "Projektname",
  email_compose_create_room: "Projekt erstellen",
  email_compose_creating_room: "Projekt wird erstellt...",
  email_no_sender: "(unbekannter Absender)",
  email_no_recipient: "(kein Empfänger)",
  email_attachments_tab: "E-MAIL",
  select_attachments: "Anhänge auswählen",
  email_attachments_empty: "Noch keine E-Mail-Anhänge",
  email_move_to_room: "In Projekt verschieben",
  email_attachment_moved: "E-Mail-Anhang verschoben",
  email_attachment_removed: "E-Mail-Anhang entfernt",
  email_attachment_remove_confirm: "Ausgewählte E-Mail-Anhänge aus diesem Projekt entfernen?",
  email_no_other_rooms: "Keine anderen Projekte verfügbar",
  email_classify_rules_title: "E-Mail-Projektzuordnung",
  email_default_project_per_account: "Standardprojekt pro Konto",
  email_sender_rules: "Absenderregeln",
  email_spam_blocklist: "Spam-Sperrliste",
  email_no_default: "Keins",
  email_select_project: "Projekt auswählen",
  info: "Info",
  email_default_project_info:
    "Wenn ein E-Mail-Konto mit einem bestimmten Projekt verknüpft ist, werden alle eingehenden E-Mails dieses Kontos automatisch diesem Projekt zugeordnet – du wirst nicht zur Projektzuordnung aufgefordert. Leer lassen, um jede E-Mail einzeln einem Projekt zuzuordnen.",
  email_account_project_title: "Konto mit Projekt verbinden?",
  email_account_project_question:
    "Wird dieses E-Mail-Konto ausschließlich für ein bestimmtes Projekt verwendet? Falls ja, wählen Sie bitte das Projekt aus. Alle eingehenden E-Mails werden diesem Projekt anschließend automatisch zugeordnet.",
  email_account_project_name_placeholder: "Name",
  email_account_create_room: "Neues Projekt erstellen",
  email_account_create_company: "Firma auswählen",
  email_account_create_submit: "Projekt erstellen & verknüpfen",
  email_account_project_link: "Konto mit Projekt verknüpfen",
  email_account_project_skip: "Nein, jede E-Mail einzeln klassifizieren",
  email_account_project_linked: "Konto mit Projekt verknüpft",
  project_confirm_title: "Meintest du dieses Projekt?",
  project_confirm_text:
    'Der Name "{typed}" ähnelt stark dem bestehenden Projekt "{existing}". Möchtest du das bestehende Projekt verwenden oder ein neues erstellen?',
  project_confirm_use_existing: '"{name}" verwenden',
  project_confirm_create_new: 'Neu "{name}" erstellen',
  attachment: "Anhang",
  attachments: "Anhänge",
  media_send_disabled: "Vom Administrator deaktiviert.",
  todo_bookmarked: "Aufgabe wurde vorgemerkt",
  bookmarked_todos: "Vorgemerkte Aufgaben",
  needs_date: "Termin zuweisen",
  needs_date_hint: "Lege einen Termin fest, um die Aufgabe einzuplanen",
  bookmarked_no_mylist: "Vorgemerkte Aufgaben können nicht zur Liste hinzugefügt werden",
  bookmark_removed: "Vorgemerkte Aufgabe entfernt.",
  bookmark_already_todo: "Diese Aufgabe wurde bereits bearbeitet und bleibt bestehen",
  new_label: "Neu",
  no_new_todos: "Keine neuen Aufgaben",
  filter_all: "Alle",
  filter_email: "E-Mail",
  filter_reports: "Tagesberichte",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Direktnachrichten",
  my_notes: "My Space",
  pin_chat: "Anpinnen",
  unpin_chat: "Lösen",
  filter_internal_groups: "Interne Gruppen-Chats",
  filter_external_groups: "Externe Gruppen-Chats",
  filter_group_chats: "Gruppen-Chats",
  filter_groups_internal: "Intern",
  filter_groups_external: "Extern",
  filter_unread_only: "Nur ungelesen",
  email_select_all: "Alle auswählen",
  email_deselect_all: "Auswahl aufheben",
  email_reply_all: "Allen antworten",
  email_reply_placeholder: "Antwort eingeben...",
  email_forward_placeholder: "Nachricht hinzufügen...",
  email_edit_draft: "Entwurf bearbeiten",
  email_attach: "Anhängen",
  email_attachment_from_original: "Aus Originalnachricht",
  email_remove: "Entfernen",
  email_drop_files: "Dateien zum Anhängen ablegen",
  email_loading_attachments: "Anhänge werden geladen...",
  email_archive: "Archivieren",
  mark_unread: "Als ungelesen markieren",
  mark_read: "Als gelesen markieren",
  email_all_accounts: "Alle Konten",
  email_error: "Fehler",
  email_delete_email_failed: "E-Mail konnte nicht gelöscht werden.",
  enter_url: "URL eingeben",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Abonnement verwalten',
  kjuup_io_subscribe_now: 'Jetzt abonnieren',
  kjuup_io_subscribe_now_short: 'Abonnieren',
  kjuup_io_hero_subtitle: 'Upgrade, um Premium-Funktionen freizuschalten und mehr herauszuholen.',
  kjuup_io_trial_badge: '1 MONAT KOSTENLOS TESTEN',
  pro_auth_register_kjuup_io_title: 'Registrierung Kjuup.io',
  pro_auth_register_kjuup_io_sub: 'Mit Ihrem Konto startet sofort Ihre kostenlose Kjuup.io-Testphase – ohne Zahlungsdaten. Wir senden Ihnen einen Link, um Ihre E-Mail-Adresse zu bestätigen.',
  kjuup_io_trial_title: 'Kjuup.io Premium freischalten',
  kjuup_io_trial_subtitle: 'Verbinde deine E-Mail, erhalte KI-gestützte Antwortvorschläge und synchronisiere deine Aufgaben automatisch mit deinem Kalender.',
  kjuup_io_trial_no_payment: 'Heute keine Zahlung.',
  kjuup_io_trial_trust: 'Heute keine Zahlung. Es werden keine Kreditkartendaten abgefragt, bevor das Bezahllabo startet.',
  kjuup_io_after_trial_monthly: 'Nach der Testphase: {price}/Monat',
  kjuup_io_after_trial_yearly: 'Nach der Testphase: {price}/Jahr',
  kjuup_io_price_per_month: '{price}/Monat',
  kjuup_io_price_per_year: '{price}/Jahr',
  kjuup_io_start_free_trial: 'Jetzt kostenlos testen',
  kjuup_io_trial_footnote: 'Heute keine Zahlung. Danach {price}. Jederzeit kündbar.',
  kjuup_io_feature_email: 'Alle E-Mail Konten direkt in Kjuup verwalten',
  kjuup_io_feature_assign: 'E-Mails und Anlagen automatisiert Projekten zuordnen',
  kjuup_io_feature_ai: 'KI schreibt Antworten – du bestätigst nur',
  kjuup_io_feature_tasks: 'Aufgaben & Kalender immer automatisch aktuell',
  kjuup_io_company_managed_title: 'Von Ihrer Firma verwaltet',
  kjuup_io_company_admins_title: 'Deine Firmen-Admins',
  kjuup_io_company_admins_hint: 'Sie können dir im Admin Panel einen Kjuup.io-Platz zuweisen.',
  kjuup_io_company_managed_body:
    'Kjuup.io für Ihre Kjuup+-Firma wird im Admin Panel gebucht und abgerechnet. Bitte wenden Sie sich an {admins}, um Zugang zu erhalten.',
  kjuup_io_company_managed_body_short:
    'Bitten Sie Ihren Firmen-Admin, Ihnen im Admin Panel einen Kjuup.io-Platz zuzuweisen.',
  kjuup_io_company_managed_body_short_admins:
    'Bitten Sie {admins} mit, Ihnen im Admin Panel einen Kjuup.io-Platz zuzuweisen.',
  kjuup_io_company_seat_active: 'Ihr Firmenplatz ist aktiv.',
  kjuup_io_open_admin_panel: 'Admin Panel öffnen',
  kjuup_io_open_admin_panel_short: 'Admin Panel',
  kjuup_io_company_trial_ended_title: 'Kostenlose Testphase beendet!',
  kjuup_io_company_trial_ended_body:
    'Das Kjuup.io Abo kann über das Admin Center zugewiesen werden.',
  kjuup_io_company_trial_ended_contact_admins:
    'Das Kjuup.io Abo kann von {admins} über das Admin Center zugewiesen werden.',
  kjuup_io_todo_calendar_trial_ended_admin: 'Kalender-Sync · Admin kontaktieren',
  kjuup_io_your_company: 'Ihre Firma',
  kjuup_io_choose_plan: 'Plan wählen',
  kjuup_io_plan_monthly: 'Monatlich',
  kjuup_io_plan_yearly: 'Jährlich',
  kjuup_io_plan_monthly_desc: 'Monatlich abgerechnet · jederzeit kündbar',
  kjuup_io_plan_yearly_desc: 'Spare {pct}% mit jährlicher Buchung',
  kjuup_io_save_badge: '{pct}% SPAREN',
  kjuup_io_per_month_annual: '{price} / Monat · Spare {pct}% mit jährlicher Buchung',
  kjuup_io_subscribe: 'Abonnieren',
  kjuup_io_secured_stripe: 'Gesichert durch Stripe · jederzeit kündbar',
  kjuup_io_your_subscription: 'DEIN ABO',
  kjuup_io_status_active: 'AKTIV',
  kjuup_io_status_cancels_soon: 'ENDEN BALD',
  kjuup_io_status_switch_scheduled: 'WECHSEL GEPLANT',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Preis',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Verlängert am',
  kjuup_io_label_access_until: 'Zugang bis',
  kjuup_io_switching_to: 'Wechsel zu {plan} am {date}',
  kjuup_io_cancel_pending_note: 'Dein Abonnement ist zur Kündigung vorgemerkt und verlängert sich nicht. Du behältst den Zugang bis zum oben genannten Datum.',
  kjuup_io_resume: 'Abonnement fortsetzen',
  kjuup_io_switch_to_plan: 'Zu {plan} wechseln',
  kjuup_io_undo_switch: 'Geplanten Wechsel rückgängig',
  kjuup_io_cancel_subscription: 'Abonnement kündigen',
  kjuup_io_switch_modal_title: 'Zu {plan} wechseln?',
  kjuup_io_billed_yearly: 'Jährlich abgerechnet',
  kjuup_io_billed_monthly: 'Monatlich abgerechnet',
  kjuup_io_switch_modal_note: 'Startet am {date}, wenn dein aktueller {plan}-Plan endet. Heute keine Gebühr — du behältst deinen aktuellen Plan bis dahin.',
  kjuup_io_confirm_switch: 'Wechsel bestätigen',
  kjuup_io_not_now: 'Nicht jetzt',
  kjuup_io_cancel_modal_title: 'Abonnement kündigen?',
  kjuup_io_cancel_modal_note: 'Du behältst den Zugang zu Kjuup.io bis zum Ende deines aktuellen Abrechnungszeitraums. Danach verlängert es sich nicht.',
  kjuup_io_cancel_modal_note_with_date: 'Du behältst den Zugang zu Kjuup.io bis zum Ende deines aktuellen Abrechnungszeitraums ({date}). Danach verlängert es sich nicht.',
  kjuup_io_cancel_plan: 'Plan kündigen',
  kjuup_io_keep_subscription: 'Abonnement behalten',
  kjuup_io_toast_payment_failed: 'Zahlung fehlgeschlagen',
  kjuup_io_toast_activating: 'Zahlung erhalten. Abonnement wird aktiviert…',
  kjuup_io_toast_activating_soon: 'Zahlung erhalten. Dein Abonnement wird in Kürze aktiviert.',
  kjuup_io_toast_cancel_period: 'Dein Abonnement endet zum Periodenende',
  kjuup_io_toast_cancel_fail: 'Abonnement konnte nicht gekündigt werden',
  kjuup_io_toast_switch_scheduled: 'Du wechselst zum {plan}-Plan, wenn die aktuelle Periode endet',
  kjuup_io_toast_switch_fail: 'Planwechsel nicht möglich',
  kjuup_io_toast_resumed: 'Dein Abonnement verlängert sich weiter',
  kjuup_io_toast_resume_fail: 'Abonnement konnte nicht fortgesetzt werden',
  kjuup_io_toast_undo: 'Geplanter Planwechsel abgebrochen',
  kjuup_io_toast_undo_fail: 'Geplanter Wechsel konnte nicht abgebrochen werden',
  kjuup_io_email_locked_body: 'E-Mail ist Teil von Kjuup.io. Aktiviere einen Plan, um den E-Mail-Tab zu nutzen.',
  kjuup_io_connect_email: 'E-Mail mit Kjuup.io verbinden',
  kjuup_io_activate_to_connect_email: 'Kjuup.io aktivieren, um E-Mail-Konten zu verbinden',
  kjuup_io_activate_to_sync_calendar: "Kjuup.io aktivieren, um Aufgaben mit meinem Kalender zu synchronisieren",
  kjuup_io_todo_calendar_chip: "Kalender-Sync · Kjuup.io aktivieren",
  kjuup_io_todo_calendar_nudge: "Aufgabe mit Kalender synchronisieren?",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.io aktivieren",
  kjuup_io_todo_calendar_trial_ended_note: "Kalender-Sync · Abonnieren",
  kjuup_io_todo_connect_calendar_banner: "Kalender verbinden",
  kjuup_io_todo_connect_calendar_cta: "Einstellungen",

  kjuup_io_trial_no_card: 'Es werden keine Kreditkartendaten abgefragt, bevor das Bezahlabo startet.',
  kjuup_io_status_trialing: 'TESTPHASE',
  kjuup_io_trial_days_left: 'Noch {days} Tage in deiner kostenlosen Testphase',
  kjuup_io_trial_left_hours: 'Noch {count} Stunden',
  kjuup_io_trial_left_hour: 'Noch 1 Stunde',
  kjuup_io_trial_left_minutes: 'Noch {count} Minuten',
  kjuup_io_trial_left_minute: 'Noch 1 Minute',
  kjuup_io_trial_left_seconds: 'Noch {count} Sekunden',
  kjuup_io_trial_left_second: 'Noch 1 Sekunde',
  kjuup_io_trial_ending_now: 'Deine Testphase endet gerade…',
  kjuup_io_request_timeout: 'Die Verbindung ist abgelaufen. Bitte versuche es erneut.',
  kjuup_io_info_days_free: '{days} Tage vollständig kostenlos – dein Abo beginnt erst nach der Testphase.',
  kjuup_io_discount_total: 'Dein Rabatt: {percent} %',
  kjuup_io_discount_company: '{company}: {percent} %',
  kjuup_io_discount_personal: 'Persönlich: {percent} %',
  kjuup_io_trial_days_short: '{days} Tage verbleibend',
  kjuup_io_trial_ends_tomorrow: 'Deine kostenlose Testphase endet morgen',
  kjuup_io_trial_ends_today: 'Deine kostenlose Testphase endet heute',
  kjuup_io_trial_ends_today_short: 'Endet heute',
  kjuup_io_trial_card_title: 'Ihr Kjuup.io-Testzeitraum endet in {days} Tagen',
  kjuup_io_trial_card_title_today: 'Ihr Kjuup.io-Testzeitraum endet heute',
  kjuup_io_trial_card_subtitle: 'Upgraden Sie jetzt, um alle Funktionen weiter zu nutzen.',
  kjuup_io_trial_card_progress: '{days} von {total} Testtagen verbleibend',
  kjuup_io_trial_card_cta: 'Jetzt upgraden',
  kjuup_io_trial_card_days_unit: 'TAGE',
  kjuup_io_trial_card_day_unit: 'TAG',
  kjuup_io_banner_dismiss: 'Schließen',
  kjuup_io_billing_after_trial: 'Die Abrechnung beginnt nach Ende der Testphase am {date}.',
  kjuup_io_trial_ended_title: 'Deine kostenlose Testphase ist beendet',
  kjuup_io_trial_ended_body: 'Abonniere Kjuup.io, um E-Mail und weitere Premium-Funktionen weiter zu nutzen.',
  kjuup_io_subscribe_to_continue: 'Jetzt abonnieren, um fortzufahren',
  kjuup_io_trial_active_title: 'Du bist in der kostenlosen Testphase',
  kjuup_io_trial_active_subtitle: 'Wähle einen Plan und abonniere — die Abrechnung beginnt am Ende der Testphase.',
  kjuup_io_toast_trial_started: 'Deine kostenlose Testphase hat begonnen',
  kjuup_io_toast_trial_fail: 'Testphase konnte nicht gestartet werden',
  kjuup_io_trial_try_month: 'Teste Kjuup.io einen Monat kostenlos.',
  kjuup_io_per_month: 'pro Monat',
  kjuup_io_price_month_line: '{price} / Monat',
  kjuup_io_billed_annually_amount: '{price} jährlich abgerechnet',
  kjuup_io_save_yearly: 'Spare {pct}% mit jährlicher Abrechnung.',
  kjuup_io_save_amount_year: 'Spare {price} pro Jahr',
  kjuup_io_savings_pct: '{pct}% Ersparnis',
  kjuup_io_features_title: 'Was du bekommst:',
  kjuup_io_info_one_month_free: 'Einen Monat kostenlos',
  kjuup_io_info_plan_after_trial: 'Dein gewähltes Abonnement beginnt nach der Testphase.',
  kjuup_io_info_cancel_trial: 'Während der Testphase jederzeit kündbar.',
  kjuup_io_info_no_card: 'Keine Kreditkarte erforderlich – starte sofort, ohne Zahlungsdaten anzugeben.',
  kjuup_io_info_cancel_anytime: 'Jederzeit kündbar – keine Bindung, kein Risiko.',
  kjuup_io_cta_plan_begins: 'Dein gewählter Plan beginnt nach der kostenlosen Testphase.',
  kjuup_io_billing_period_aria: 'Abrechnungszeitraum',
  kjuup_io_subscription_info_title: 'Abo-Informationen',
  kjuup_io_first_payment_on: 'Erste Zahlung am {date}.',
  kjuup_io_renews_on: 'Verlängert am {date}.',
  kjuup_io_toast_card_saved: 'Zahlungsmethode gespeichert. Abrechnung erfolgt am Ende der Testphase.',
  article_new_badge: 'NEU',
  article_new_posts: '{0} neue Beiträge',
  documents: 'Dokumente',
  add_documents: 'Dokumente hinzufügen',
  no_preview_available: 'Keine Vorschau verfügbar',
  no_preview_hint: 'Dieser Dateityp kann nicht in der Vorschau angezeigt werden, wird aber trotzdem gesendet.',
  max_documents_reached: 'Du kannst bis zu 10 Dokumente gleichzeitig anhängen.',
  open_file: 'Datei herunterladen',
  spreadsheet_preview_truncated: 'Die ersten 250 Zeilen werden angezeigt',
  twofa_title: 'Zwei-Faktor-Authentifizierung',
  twofa_method_totp: 'Authenticator-App',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-Mail',
  twofa_enter_app: 'Gib den 6-stelligen Code aus deiner Authenticator-App ein.',
  twofa_enter_sms: 'Gib den 6-stelligen Code ein, den wir per SMS gesendet haben.',
  twofa_enter_email: 'Gib den 6-stelligen Code ein, den wir an deine E-Mail gesendet haben.',
  twofa_resend: 'Code erneut senden',
  twofa_try_another: 'Andere Methode versuchen',
  twofa_remember_device: 'Auf diesem Gerät 30 Tage lang nicht mehr fragen',
  twofa_sent: 'Wir haben einen Code gesendet.',
  twofa_invalid_code: 'Dieser Code ist falsch. Bitte versuche es erneut.',
  twofa_something_wrong: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
  twofa_method_unavailable: 'Diese Bestätigungsmethode ist nicht verfügbar.',
  twofa_on_desc: 'Die Zwei-Faktor-Authentifizierung ist aktiv. Bei jeder Anmeldung brauchst du einen Code.',
  twofa_off_desc: 'Füge nach dem Passwort einen zweiten Schritt hinzu. Authenticator-Apps sind am sichersten.',
  twofa_methods: 'Methoden',
  twofa_on: 'Aktiv',
  twofa_add: 'Hinzufügen',
  twofa_default_method: 'Standardmethode',
  twofa_default: 'Standard',
  twofa_turn_off: 'Deaktivieren',
  twofa_disable_hint: 'Gib dein Passwort und einen aktuellen Code ein, um die Zwei-Faktor-Authentifizierung zu deaktivieren.',
  twofa_disable_need: 'Gib dein Passwort und einen Bestätigungscode ein.',
  twofa_code_placeholder: '6-stelliger Code oder Backup-Code',
  twofa_send_code: 'Code senden',
  twofa_primary_updated: 'Standardmethode wurde aktualisiert.',
  twofa_disabled: 'Die Zwei-Faktor-Authentifizierung ist jetzt deaktiviert.',
  twofa_enabled: 'Die Zwei-Faktor-Authentifizierung ist jetzt aktiv.',
  twofa_totp_help: 'Scanne diesen QR-Code mit Google Authenticator, Authy oder 1Password. Du kannst den Schlüssel auch manuell eingeben.',
  twofa_secret_copied: 'Schlüssel kopiert',
  twofa_sms_help: 'Gib deine Mobilnummer im internationalen Format ein. Wir senden einen 6-stelligen Code per SMS.',
  twofa_email_help: 'Wir senden einen 6-stelligen Code an die E-Mail-Adresse deines Kontos.',
  twofa_backup_title: 'Backup-Codes',
  twofa_backup_help: 'Bewahre diese Einmal-Codes sicher auf. Jeder Code kann einmal genutzt werden, wenn du dein Handy verlierst.',
  twofa_copy_codes: 'Codes kopieren',
  twofa_codes_copied: 'Backup-Codes kopiert',
  twofa_regenerate: 'Neue Backup-Codes erstellen',
  twofa_regenerate_hint: 'Damit werden ungenutzte Backup-Codes ersetzt. Gib dein Passwort und einen aktuellen Code ein.',
  twofa_backup_remaining: '{n} ungenutzte Backup-Codes übrig',
  twofa_new_codes: 'Neue Backup-Codes',
  twofa_sms_unavailable: 'SMS-Codes sind noch nicht verfügbar.',

  // ─── Cockpit (personal start page) ───────────────────────────────────────
  next: "Weiter",
  nav_news: "News",
  nav_email: "E-Mail",
  nav_addons: "Optional",
  nav_soon: "bald",
  nav_off: "aus",
  addon_click_to_enable: "deaktiviert, klicken zum Aktivieren",
  addon_enable: "Aktivieren",
  addon_enable_confirm: "Add-on aktivieren?",
  addon_enabled: "Add-on aktiviert",
  addon_chats_enable_confirm: "Kjuup-Chats aktivieren? Chats werden wieder unter Nachrichten und in den Projekten angezeigt.",
  addon_chats_enabled: "Kjuup-Chats aktiviert",
  nav_recommend: "Weiterempfehlen",
  startup_screen_cockpit: "Cockpit",
  recommend_text: "Komm zu Kjuup, bleib in Verbindung und behalte deine Kommunikation im Griff. Bring deine Kanäle zusammen, halte Nachrichten in den richtigen Projekten und starte jeden Morgen mit einer Zusammenfassung und deinen Aufgaben – alles synchronisiert mit den Apps, die du schon nutzt. Kostenlos loslegen:",
  recommend_copied: "Empfehlungslink kopiert",
  recommend_subject: "Empfehlung: Kjuup",
  products_kjuup_plus_sub: "für Unternehmen",
  products_kjuup_io_sub: "testen oder buchen",
  products_kjuup_io_sub_trial: "kostenlos testen",
  products_kjuup_plus_sub_active: "Aktiv über Firma",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Abo",
  kjuup_plus_abo_title: "Kjuup+ Paket",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (bis {max} Mitarbeitende)",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (bis {max} Mitarbeitende)",
  kjuup_plus_abo_status_active: "Aktiv",
  kjuup_plus_abo_status_ends: "Endet am {date}",
  kjuup_plus_abo_status_requested: "Kündigung angefragt",
  kjuup_plus_abo_status_past_due: "Zahlung offen",
  kjuup_plus_abo_seats_used: "{used} von {total} Plätzen belegt",
  kjuup_plus_abo_seats_free: "Noch {count} Plätze frei",
  kjuup_plus_abo_seats_free_one: "Noch 1 Platz frei",
  kjuup_plus_abo_seats_next: "Kommen mehr Mitarbeitende dazu, wechselt das Paket automatisch zu {next} (anteilig berechnet).",
  kjuup_plus_abo_seats_over: "Mehr als {max} Mitarbeitende – Kjuup meldet sich mit einem individuellen Angebot.",
  kjuup_plus_abo_billing: "Zahlweise",
  kjuup_plus_abo_monthly: "Monatlich",
  kjuup_plus_abo_yearly: "Jährlich",
  kjuup_plus_abo_amount: "Betrag",
  kjuup_plus_abo_per_month: "/ Monat",
  kjuup_plus_abo_per_year: "/ Jahr",
  kjuup_plus_abo_renews: "Nächste Verlängerung",
  kjuup_plus_abo_ends: "Endet am",
  kjuup_plus_abo_next_invoice: "Nächste Rechnung",
  kjuup_plus_abo_intro: "Einführungspreis",
  kjuup_plus_abo_intro_until: "bis {date}",
  kjuup_plus_abo_pending_tier: "Ab nächster Verlängerung",
  kjuup_plus_abo_manual: "Kjuup+ ist für deine Firma über eine individuelle Vereinbarung aktiv.",
  kjuup_plus_abo_invoices: "Rechnungen",
  kjuup_plus_abo_invoice_paid: "Bezahlt",
  kjuup_plus_abo_invoice_open: "Offen · fällig {date}",
  kjuup_plus_abo_invoice_view: "Ansehen",
  kjuup_plus_abo_invoices_all: "Alle {count} anzeigen",
  kjuup_plus_abo_invoices_less: "Weniger anzeigen",
  kjuup_plus_abo_member_hint: "Abrechnung und Kündigung verwalten die Firmen-Admins.",
  kjuup_plus_abo_cancel: "Abo kündigen",
  kjuup_plus_abo_cancel_hint: "Kjuup prüft deine Anfrage und bestätigt die Kündigung zum Ende der Laufzeit ({end}). Bis dahin bleibt Kjuup+ aktiv.",
  kjuup_plus_abo_cancel_note: "Grund (optional)",
  kjuup_plus_abo_cancel_send: "Kündigung anfragen",
  kjuup_plus_abo_requested: "Kündigung angefragt",
  kjuup_plus_abo_requested_hint: "Kündigung am {date} angefragt. Kjuup bestätigt sie zum Ende der Laufzeit ({end}).",
  kjuup_plus_abo_withdraw: "Anfrage zurückziehen",
  kjuup_plus_abo_withdrawn: "Kündigungsanfrage zurückgezogen",
  products_sub_active: "Abo aktiv",
  products_sub_trialing: "Testphase aktiv",
  kjuup_io_seat_company_admin_only: "Das Kjuup.io-Paket für dein Konto kann nur von deinem Firmen-Admin gebucht werden. Wende dich für deinen Kjuup.io-Platz an deinen Firmen-Admin.",
  kjuup_io_seat_company_admins: "Das Kjuup.io-Paket für dein Konto kann nur von deinen Firmen-Admins {{admins}} gebucht werden. Wende dich für deinen Kjuup.io-Platz an {{admins}}.",
  cockpit_plus_io_ask_admins: "Das Kjuup.io-Paket für dein Konto kann nur von deinen Firmen-Admins gebucht werden.",
  cockpit_io_contact_admin: "Kontakt",
  cockpit_active_plan: "Aktives Abo",
  cockpit_io_plan: "Kjuup.io Abo",
  cockpit_io_settings: "Kjuup.io Einstellungen",
  cockpit_io_settings_sub: "Plan und Plätze, Zuweisung der Mitarbeitenden sowie Abrechnung und Rechnungen.",
  products_josch_sub: "dein persönlicher Büroassistent",
  products_projektview_sub: "smartes Projekt-Controlling",
  products_kostenprognose_sub: "Kostenprognosen für Bauprojekte",
  products_terminplan_sub: "Terminplanung für Bauprojekte",
  products_coming_soon: "Bald verfügbar",
  products_teaser_generic: "Dieses Produkt wird gerade entwickelt und erscheint hier, sobald es verfügbar ist. Es ist dann direkt aus deinem Kjuup-Konto nutzbar.",
  products_josch_teaser: "Josch.IO wird dein persönlicher Büroassistent: Er nimmt Anrufe an, sortiert Anfragen, bereitet Antworten vor und hält deine Projekte auf dem neuesten Stand.",
  products_projektview_teaser: "ProjektView bringt Klarheit in komplexe Bauprojekte: Termine, Kosten und Entscheidungen auf einen Blick – verbunden mit deinen Kjuup-Projekten.",
  products_kostenprognose_teaser: "Kostenprognose.IO berechnet aus Ausschreibungen, Nachträgen und Marktdaten eine belastbare Kostenprognose für dein Projekt.",
  products_terminplan_teaser: "Terminplan.IO plant Bauabläufe, erkennt Verzüge früh und synchronisiert Termine mit deinen Aufgaben in Kjuup.",
  cockpit_title: "Cockpit",
  nav_my_cockpit: "Mein Cockpit",
  cockpit_my_tasks: "Meine Aufgaben",
  cockpit_my_tasks_today: "Heute zu erledigen",
  cockpit_my_tasks_sub: "Vorgemerkte Aufgaben und Aufgaben",
  cockpit_today_tasks_group: "Aufgaben heute",
  cockpit_today_tasks: "Heute",
  cockpit_today_tasks_empty: "Für heute stehen keine Aufgaben an.",
  cockpit_greeting_morning: "Guten Morgen",
  cockpit_greeting_day: "Guten Tag",
  cockpit_greeting_evening: "Guten Abend",
  cockpit_day_overview: "Dein Tag im Überblick",
  cockpit_assign_proposal: "{{name}} erkannt – zuweisen?",
  cockpit_assign_proposal_confirm: "Zuweisen",
  cockpit_assign_proposal_dismiss: "Ignorieren",
  cockpit_todo_set_date: "Datum festlegen",
  cockpit_row_more_actions: "Weitere Aktionen",
  cockpit_my_tasks_title: "Meine Aufgaben",
  cockpit_task_delete_failed: "Die Aufgabe konnte nicht gelöscht werden.",
  cockpit_channels_title: "Kanäle",
  cockpit_channel_chat: "Kjuup-Chat",
  cockpit_channel_email: "E-Mail",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_forward: "Weiterleitungsadresse",
  cockpit_channel_not_set_up: "Nicht eingerichtet",
  cockpit_channel_set_up: "Einrichten",
  cockpit_channel_active: "Aktiv",
  cockpit_channel_hidden: "Ausgeblendet",
  cockpit_channel_enable: "Aktivieren",
  cockpit_channel_connected: "Verbunden",
  cockpit_channel_not_connected: "Nicht verbunden",
  cockpit_channel_connect: "Verbinden",
  cockpit_channel_check: "Verbindung prüfen",
  cockpit_channel_fix: "Prüfen",
  cockpit_channel_broken: "Verbindung unterbrochen",
  cockpit_channel_reconnect: "Neu verbinden",
  cockpit_channel_importing: "Import läuft",
  cockpit_channel_removing: "Wird getrennt",
  cockpit_report_top5: "Top 5 Prioritäten",
  cockpit_meta_rooms: "{{n}} aktive Projekte",
  cockpit_meta_participants: "{{n}} Beteiligte",
  cockpit_filter_project: "Projekt",
  cockpit_filter_all_projects: "Alle Projekte",
  cockpit_refresh: "Aktualisieren",
  cockpit_tab_overview: "Übersicht",
  cockpit_tab_company: "Firma",
  cockpit_load_error: "Das Cockpit konnte nicht geladen werden.",
  cockpit_retry: "Erneut versuchen",
  cockpit_yesterday: "Gestern",
  cockpit_last: "zuletzt",
  cockpit_next: "nächster",
  cockpit_kpi_today: "Heute",
  cockpit_kpi_today_desc: "Aufgaben und Termine",
  cockpit_kpi_today_hint: "Aufgaben mit heutigem Datum",
  cockpit_kpi_today_tasks: "Heutige Aufgaben",
  cockpit_kpi_today_tasks_desc: "Aufgaben mit heutigem Datum",
  cockpit_kpi_today_tasks_none: "Keine Aufgaben für heute",
  cockpit_kpi_today_tasks_in_list: "In der Aufgabenliste",
  cockpit_kpi_news: "News",
  cockpit_kpi_news_desc: "Neue Artikel",
  cockpit_kpi_news_external: "{{n}} extern",
  cockpit_kpi_news_internal: "{{n}} intern",
  cockpit_kpi_news_none: "Keine neuen Artikel",
  cockpit_kpi_bookmarks: "Vorgemerkte Aufgaben",
  cockpit_kpi_tasks: "Aufgaben",
  cockpit_kpi_deadlines: "Fristen",
  cockpit_kpi_appointments: "Termine",
  cockpit_kpi_deadlines_tasks: "Fristen & Aufgaben",
  cockpit_group_tasks: "Fristen & Aufgaben",
  cockpit_group_appointments: "Termine",
  cockpit_kpi_bookmarks_desc: "Aufgaben erstellen",
  cockpit_kpi_bookmarks_none: "Keine vorgemerkten Aufgaben",
  cockpit_kpi_next_at: "Nächster Termin um {{time}} Uhr",
  cockpit_kpi_overdue: "Überfällig",
  cockpit_kpi_overdue_desc: "brauchen deine Entscheidung",
  cockpit_kpi_overdue_hint: "Frist überschritten",
  cockpit_kpi_overdue_none: "Alles im Zeitplan",
  cockpit_kpi_requested: "Abgefordert",
  cockpit_kpi_requested_desc: "Antworten und Zuarbeiten nachhalten",
  cockpit_kpi_requested_hint: "Von dir angefordert, noch offen",
  cockpit_kpi_requested_none: "Keine offenen Rückmeldungen",
  cockpit_kpi_messages: "Neue Nachrichten",
  cockpit_kpi_chats_n: "{{n}} Chats",
  cockpit_kpi_emails_n: "{{n}} E-Mails",
  cockpit_kpi_messages_project: "davon {{n}} projektbezogen",
  cockpit_priority_eyebrow: "Fokus",
  cockpit_priority_title: "Jetzt wichtig",
  cockpit_priority_empty: "Nichts Dringendes",
  cockpit_priority_empty_hint: "Überfällige, heutige und angeforderte Aufgaben erscheinen hier.",
  cockpit_all_tasks: "Alle Aufgaben",
  cockpit_chip_overdue: "Überfällig",
  cockpit_chip_today: "Heute",
  cockpit_calendar_week: "KW {{week}}",
  cockpit_prev_week: "Vorherige Woche",
  cockpit_next_week: "Nächste Woche",
  cockpit_chip_requested: "Abgefordert",
  cockpit_todo_due: "Frist {{when}}",
  cockpit_todo_at: "{{time}} Uhr",
  cockpit_todo_requested_from: "bei {{name}}",
  cockpit_todo_since: "seit {{when}}",
  cockpit_todo_no_date: "Ohne Datum",
  cockpit_todo_no_project: "Kein Projekt",
  cockpit_todo_change_project: "Projekt ändern",
  no_project_found: "Kein Projekt gefunden",
  cockpit_todo_general: "Allgemein",
  cockpit_todo_mark_done: "Als erledigt markieren",
  pro_todo_not_found: "Diese Aufgabe ist nicht mehr verfügbar.",
  pro_todo_step_done: "Erledigt",
  pro_todo_status: "Status",
  todo_calendar_add: "Zum Kalender hinzufügen",
  todo_calendar_remove: "Aus dem Kalender entfernen",
  todo_calendar_added: "Zu deinem Kalender hinzugefügt",
  todo_calendar_added_later: "Hinzugefügt. Dein Kalender war nicht erreichbar, Kjuup versucht es später erneut.",
  todo_calendar_removed: "Aus deinem Kalender entfernt",
  todo_calendar_no_date: "Nur eine Aufgabe mit Datum kann zum Kalender hinzugefügt werden.",
  todo_calendar_failed: "Dein Kalender konnte nicht aktualisiert werden. Bitte versuche es erneut.",
  todo_calendar_connect_title: "Kein Kalender verbunden",
  todo_calendar_connect_body_web: "Verbinde in den Kalender-Sync-Einstellungen einen Kalender, um Aufgaben hinzuzufügen.",
  todo_calendar_connect: "Verbinden",
  todo_calendar_date_title: "Noch kein Datum",
  todo_calendar_date_body_web: "Diese vorgemerkte Aufgabe hat noch kein Datum. Lege eins fest, um sie zu deinem Kalender hinzuzufügen.",
  todo_calendar_date_save: "Datum setzen & hinzufügen",
  cockpit_assign_none: "Niemand zugewiesen",
  cockpit_today_eyebrow: "Heute",
  cockpit_today_title: "Mein Tag",
  cockpit_tasks: "Aufgaben",
  cockpit_priority_date: "Datum",
  cockpit_priority_save: "Als Aufgabe",
  cockpit_today_count: "{{n}} offen",
  cockpit_today_empty: "Keine Aufgaben für heute",
  cockpit_today_empty_hint: "Neue Aufgaben aus Chats, E-Mails und Tagesberichten erscheinen hier.",
  cockpit_upcoming_title: "Nächste Termine",
  cockpit_upcoming_sub: "Aufgaben mit Datum in den nächsten 7 Tagen",
  cockpit_upcoming_n: "{{n}} in 7 Tagen",
  cockpit_upcoming_empty: "Keine Termine in den nächsten 7 Tagen",
  cockpit_report_eyebrow: "Kjuup-Email",
  cockpit_report_title: "Tagesberichte",
  cockpit_report_all_projects: "Alle Projekte",
  cockpit_report_show_all: "Alle {{n}} Tagesberichte anzeigen",
  cockpit_report_show_less: "Weniger anzeigen",
  cockpit_report_show_previous: "Vorherige Tagesberichte anzeigen",
  cockpit_report_hide_previous: "Vorherige Tagesberichte ausblenden",
  cockpit_report_delete: "Tagesbericht löschen",
  cockpit_report_delete_confirm: "Diesen Tagesbericht löschen?",
  cockpit_report_deleted: "Tagesbericht gelöscht",
  cockpit_report_unread: "Neu",
  cockpit_report_empty: "Noch kein Tagesbericht",
  cockpit_report_time_hint: "Der Tagesbericht wird täglich um {{hour}}:00 Uhr für die fünf aktivsten Projekte erstellt.",
  cockpit_report_needs_mailbox: "Verbinde ein E-Mail-Konto, damit Kjuup täglich einen Tagesbericht mit automatischen Aufgaben erstellt.",
  cockpit_report_create: "Tagesbericht erstellen",
  cockpit_report_clear_project: "Alle Projekte anzeigen",
  cockpit_report_creating: "Der Tagesbericht wird erstellt …",
  cockpit_report_recreate: "Tagesbericht neu erstellen",
  cockpit_report_progress_queued: "Der Bericht wird vorbereitet",
  cockpit_report_progress_collecting: "E-Mails, Chats und Aufgaben deiner Projekte werden gesammelt",
  cockpit_report_progress_reading: "Bereits ausgewertete Inhalte werden übernommen",
  cockpit_report_progress_summarizing: "Inhalte werden ausgewertet",
  cockpit_report_progress_emails: "E-Mails werden ausgewertet",
  cockpit_report_progress_chats: "Chat-Nachrichten werden ausgewertet",
  cockpit_report_progress_documents: "Anhänge und Dokumente werden ausgewertet",
  cockpit_report_progress_tasks: "Aufgaben werden ausgewertet",
  cockpit_report_progress_priorities: "Prioritäten, Fristen und Entscheidungen werden zusammengestellt",
  cockpit_report_progress_count: "{{count}} Inhalte ausgewertet",
  cockpit_report_progress_count_one: "1 Inhalt ausgewertet",
  cockpit_report_progress_count_many: "{{count}} Inhalte ausgewertet",
  cockpit_report_progress_hint: "Das dauert meist ein bis zwei Minuten – du kannst das Cockpit währenddessen weiter nutzen.",
  cockpit_report_creating_title: "Dein Tagesbericht entsteht",
  cockpit_report_created: "Tagesbericht erstellt",
  cockpit_report_create_failed: "Der Tagesbericht konnte nicht erstellt werden.",
  cockpit_report_no_activity: "In diesem Projekt gab es in den letzten 24 Stunden keine neuen Nachrichten oder E-Mails.",
  cockpit_report_room_unavailable: "Dieses Projekt ist nicht verfügbar.",
  cockpit_report_room_empty: "Noch kein Tagesbericht für dieses Projekt",
  cockpit_report_room_empty_hint: "Erstelle einen Tagesbericht nur für dieses Projekt.",
  cockpit_report_fazit: "Tagesbericht",
  cockpit_report_active_rooms: "Aktive Projekte",
  cockpit_report_priorities: "Wichtige Aufgaben",
  cockpit_bookmarked_priorities: "Vorgemerkte Aufgaben",
  cockpit_priorities_select: "Mehrere löschen",
  cockpit_priorities_selected: "{count} ausgewählt",
  cockpit_priorities_deleting: "Wird gelöscht …",
  cockpit_priorities_delete_confirm: "Möchtest du {count} vorgemerkte Aufgaben wirklich löschen?",
  cockpit_priorities_deleted: "{count} Aufgaben gelöscht",
  cockpit_priorities_delete_failed: "{count} Aufgaben konnten nicht gelöscht werden",
  cockpit_report_appointments: "Termine",
  cockpit_report_create_todo: "Aufgabe erstellen",
  cockpit_report_source_missing: "Die Ausgangsnachricht wurde nicht gefunden.",
  cockpit_report_todo_created: "Aufgabe erstellt",
  cockpit_report_todo_noted: "Aufgabe vorgemerkt",
  cockpit_report_none: "Keine Einträge.",
  cockpit_assistant_title: "Kjuup-Assistent",
  cockpit_assistant_hint: "Antippen und fragen",
  cockpit_assistant_new: "{{n}} neu",
  cockpit_assistant_important: "{{n}} wichtig",
  cockpit_assistant_q_open: "Was ist heute offen?",
  cockpit_assistant_q_summarize: "Fasse den Chat {{room}} zusammen",
  cockpit_assistant_q_overdue: "Welche Aufgaben sind überfällig?",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_connect: "E-Mail verbinden",
  cockpit_email_none_title: "Noch kein E-Mail-Konto verbunden",
  cockpit_email_none_client: "Verbinde Gmail, Outlook oder IMAP, um E-Mails direkt in Kjuup.io zu lesen, zuzuordnen und zu beantworten.",
  cockpit_email_none_reports: "Verbinde dein Postfach, damit Kjuup eingehende E-Mails deinen Projekten zuordnet und daraus Tagesberichte mit Aufgaben erstellt.",
  cockpit_email_reports_title: "Bisheriger E-Mail-Client",
  cockpit_email_reports_text: "Kein Postfach in Kjuup.io · {{rooms}} Projekte mit Tagesbericht um {{hour}}:00 Uhr · Eingehende E-Mails werden deinen Projekten zugeordnet.",
  cockpit_email_incoming_title: "E-Mails",
  cockpit_email_incoming_sub: "Ordne eingehende und gesendete E-Mails deinen Projekten zu. Die Zuordnung kannst du hier anpassen.",
  cockpit_email_incoming_empty: "Noch keine eingehenden E-Mails.",
  cockpit_email_sent_empty: "Noch keine gesendeten E-Mails.",
  cockpit_email_folder_inbox: "Eingang",
  cockpit_email_folder_sent: "Gesendet",
  cockpit_email_deleted: "E-Mail gelöscht",
  cockpit_email_incoming_unassigned: "Nicht zugeordnet",
  cockpit_email_incoming_unassigned_n: "{{n}} nicht zugeordnet",
  cockpit_email_incoming_pick: "Projekt wählen …",
  cockpit_email_incoming_adjust: "Zuordnung anpassen",
  cockpit_email_incoming_remove: "Zuordnung entfernen",
  cockpit_email_incoming_suggested: "Vorschlag: {{room}}",
  cockpit_email_incoming_apply: "Übernehmen",
  cockpit_email_incoming_saving: "Speichern …",
  cockpit_email_incoming_show_all: "Alle {{n}} anzeigen",
  cockpit_email_incoming_show_less: "Weniger anzeigen",
  cockpit_email_reports_rooms: "Projekte verwalten",
  cockpit_email_settings: "E-Mail-Einstellungen",
  cockpit_email_client_title: "Empfang eingerichtet",
  cockpit_email_error_title: "Verbindung prüfen",
  cockpit_email_accounts_n: "{{n}} Konto verbunden",
  cockpit_email_last_sync: "letzter Abruf {{when}}",
  cockpit_email_report_at: "Tagesbericht um {{hour}}:00 Uhr",
  cockpit_email_open_inbox: "Postfach öffnen",
  cockpit_email_open: "E-Mail öffnen",
  cockpit_email_detail_loading: "E-Mail wird geladen …",
  cockpit_email_detail_empty: "Diese E-Mail hat keinen Text.",
  cockpit_email_detail_failed: "E-Mail konnte nicht geladen werden.",
  cockpit_email_accounts_label: "Verbundene E-Mail-Adressen",
  cockpit_messages_title: "Neueste Nachrichten",
  cockpit_messages_sub_both: "Chats und E-Mails aus allen Projekten",
  cockpit_messages_sub_chats: "Chats aus allen Projekten",
  cockpit_messages_sub_emails: "E-Mails aus allen Projekten",
  cockpit_messages_empty: "Keine neuen Nachrichten",
  cockpit_all_messages: "Alle Nachrichten",
  cockpit_n_unread: "{{n}} ungelesen",
  cockpit_src_chat: "Chat",
  cockpit_src_email: "E-Mail",
  cockpit_projects_title: "Projekte",
  cockpit_projects_sub: "Projekte mit Status und Aktivität",
  cockpit_projects_action: "{{n}} Handlungsbedarf",
  cockpit_projects_empty: "Noch keine Projekte",
  cockpit_projects_empty_hint: "Lege dein wichtigstes Projekt an.",
  cockpit_col_project: "Projekt",
  cockpit_col_status: "Status",
  cockpit_col_participants: "Beteiligte",
  cockpit_col_open_tasks: "Offene Aufgaben",
  cockpit_col_new_messages: "Neue Nachrichten",
  cockpit_col_last_activity: "Letzte Aktivität",
  cockpit_status_action: "Handlungsbedarf",
  cockpit_status_open: "Aufgaben offen",
  cockpit_status_ok: "Im Plan",
  cockpit_room_internal: "Intern",
  cockpit_room_external: "Extern",
  cockpit_upsell_io_title: "Dein Büro, das mitdenkt",
  cockpit_upsell_io_text: "Verbinde deine E-Mail-Konten mit Kjuup. E-Mails, Anhänge und Nachrichten werden automatisch im passenden Projekt gespeichert und können optional auf deinem Server abgelegt werden. Täglich bekommst du eine Zusammenfassung aller Projekte mit den wichtigsten Punkten aus allen Inhalten, und deine Aufgaben synchronisieren sich mit deinem Kalender oder deiner To-do-App.",
  cockpit_upsell_io_f1: "E-Mail-Client mit Projektzuordnung",
  cockpit_upsell_io_f2: "Tagesbericht mit automatischen Aufgaben",
  cockpit_upsell_io_f3: "Kjuup-Assistent für Zusammenfassungen",
  cockpit_upsell_io_cta_trial: "Kjuup.io kostenlos testen",
  cockpit_upsell_io_cta_book: "Kjuup.io buchen",
  cockpit_upsell_io_cta_request: "Informationen anfragen",
  cockpit_upsell_io_soon_title: "Noch nicht buchbar",
  cockpit_upsell_io_soon_text: "Kjuup.io startet bald. Frag jetzt Informationen an – wir melden uns, sobald du Kjuup.io buchen kannst.",
  cockpit_upsell_io_planned_price: "Geplanter Preis",
  cockpit_upsell_io_note: "Buchung in den persönlichen Einstellungen.",
  cockpit_upsell_io_note_request: "Wir melden uns bei dir.",
  cockpit_upsell_plus_title: "Kjuup+ für Unternehmen",
  cockpit_upsell_plus_text: "Verwalte Mitarbeitende, Schreibrechte und die Firmenkommunikation an einem Ort. Interne Kanäle bleiben bei deinen Mitarbeitenden, externe Kanäle verbinden dich mit Projektpartnern, und bestimmte Gruppen informierst du gezielt. Zusätzlich zu Kjuup+ kannst du Kjuup.io-Zugänge für Mitarbeitergruppen buchen. Kjuup+ und Kjuup.io sind kombinierbar.",
  cockpit_upsell_plus_f1: "Kommunikationsaktivitäten aller Mitarbeitenden verwalten",
  cockpit_upsell_plus_f2: "Bestimmte Benutzergruppen innerhalb der Firma informieren",
  cockpit_upsell_plus_f3: "Interne Gruppenchats speichern",
  cockpit_upsell_plus_cta: "Unverbindlich anfragen",
  cockpit_upsell_plus_note: "Öffnet das Anfrageformular auf kjuup.de. Wir melden uns bei dir.",
  cockpit_upsell_plus_badge: "EINFÜHRUNGSPREIS FÜR {months} MONATE",
  cockpit_upsell_plus_size: "Unternehmensgröße",
  cockpit_upsell_plus_size_small: "1–50 Mitarbeitende",
  cockpit_upsell_plus_size_large: "51–200 Mitarbeitende",
  cockpit_upsell_plus_billing: "Zahlweise",
  cockpit_upsell_plus_per_company: "/ Firma · Monat zzgl. MwSt.",
  cockpit_upsell_plus_intro_hint: "erste {months} Monate, danach {price}",
  cockpit_upsell_plus_when_yearly: "bei jährlicher Zahlung",
  cockpit_upsell_plus_onboarding: "Kosten Onboarding/Einführung abhängig von Firmengröße",
  cockpit_upsell_plus_larger: "Preise für größere Firmen auf Anfrage",
  cockpit_plus_io_title: "Kjuup.io für dein Team",
  cockpit_plus_io_admin: "Als Firmen-Admin buchst du Kjuup.io für dich und dein Team in den persönlichen Einstellungen.",
  cockpit_plus_io_member: "Kjuup.io wird über deine Firma gebucht. Wende dich an {{admins}}.",
  cockpit_plus_io_member_generic: "Kjuup.io wird über deine Firma gebucht. Wende dich an einen Firmen-Admin.",
  cockpit_plus_io_view: "Kjuup.io ansehen",
  cockpit_plus_io_not_enabled: "Kjuup.io ist für deine Firma noch nicht freigeschaltet. Fordere die Aktivierung an, wir melden uns bei dir.",
  cockpit_setup_title: "Einrichtung abschließen",
  cockpit_setup_text: "Entscheide, ob du Chats nutzen möchtest und ob Kjuup.io als E-Mail-Client arbeiten soll oder nur Projekte mit Tagesberichten.",
  cockpit_setup_cta: "Jetzt einrichten",
  cockpit_company_eyebrow: "Firma",
  cockpit_back: "Zurück zur Übersicht",
  cockpit_company_none: "Keine Kjuup+ Firma gefunden",
  cockpit_company_profile: "Firmenprofil",
  cockpit_companies: "Firmen",
  cockpit_company_settings: "Firmeneinstellungen",
  cockpit_personal_settings: "Persönliche Einstellungen",
  cockpit_company_inactive: "inaktiv",
  cockpit_company_employees: "Mitarbeitende",
  cockpit_company_internal_rooms: "Interne Projekte",
  oversight_tab_members: "Mitglieder",
  rooms_oversight: "Supervision",
  rooms_oversight_info: "Firmen-Admins sehen unter Supervision alle Kjuup-Chatdaten aller Mitarbeiter und verwalten die Schreibrechte in den Chats.",
  oversight_rooms_description: "Wähle ein Projekt, um die zugehörigen Mitglieder sowie alle gesammelten Medien und Chats aller Mitarbeitenden anzuzeigen.",
  archived_rooms: "Archivierte Projekte",
  oversight_no_rooms: "Keine Projekte gefunden",
  oversight_no_rooms_match: "Keine Projekte gefunden, die der Suche entsprechen",
  oversight_rooms_load_error: "Die Projekte konnten nicht geladen werden.",
  oversight_archive_room: "Projekt archivieren",
  oversight_restore_room: "Projekt wiederherstellen",
  oversight_archive_room_title: "Dieses Projekt archivieren?",
  oversight_restore_room_title: "Dieses Projekt wiederherstellen?",
  oversight_archive_room_desc: "Das Projekt \"{room}\" wird archiviert und in der App ausgeblendet. Diese Funktion ist nur für interne Projekte verfügbar.",
  oversight_restore_room_desc: "Das Projekt \"{room}\" wird wiederhergestellt und ist in der App wieder sichtbar. Diese Funktion ist nur für interne Projekte verfügbar.",
  oversight_archive_action: "Archivieren",
  oversight_restore_action: "Wiederherstellen",
  oversight_archive_room_success: "Projekt erfolgreich archiviert",
  oversight_restore_room_success: "Projekt erfolgreich wiederhergestellt",
  oversight_archive_room_error: "Archivierung des Projekts fehlgeschlagen",
  oversight_restore_room_error: "Wiederherstellung des Projekts fehlgeschlagen",
  cockpit_room_admin: "Projekt- & Chat-Verwaltung",
  cockpit_room_admin_sub: "Alle Projekte der Firma mit Mitgliedern, Medien und Chats.",
  cockpit_company_admins: "Ansprechpartner",
  cockpit_company_admins_sub: "Firmen-Admins deiner Firma",
  cockpit_company_admins_none: "Keine Admins hinterlegt",
  cockpit_company_rooms_sub: "{{n}} Projekte in deiner Firma",
  cockpit_company_rooms_none: "Noch keine internen Projekte",
  cockpit_company_rooms_show_all: "Alle {{n}} internen Projekte anzeigen",
  cockpit_company_rooms_show_less: "Weniger anzeigen",
  cockpit_company_news: "Interne News",
  cockpit_company_admin_title: "Admin-Bereich",
  cockpit_company_admin_sub: "Verwaltung deiner Firma, direkt in Kjuup",
  cockpit_company_role_super_admin: "Firmen-Admin",
  cockpit_company_role_admin: "Abteilungs-Admin",
  cockpit_company_role_dept_admin: "Abteilungs-Admin",
  cockpit_company_role_member: "Mitarbeiter:in",
  kjuup_io_setup_step: "Schritt",
  kjuup_io_setup_chats_title: "Möchtest du Chats nutzen?",
  kjuup_io_setup_chats_sub: "Chats mit Kolleg:innen und Projektpartnern sind optional. Du kannst sie jederzeit im Cockpit ein- oder ausblenden.",
  kjuup_io_setup_chats_yes: "Ja, Chats anzeigen",
  kjuup_io_setup_chats_yes_text: "Nachrichten enthält Chats und E-Mails. Projekte haben Gruppenchats für alle Beteiligten.",
  kjuup_io_setup_chats_no: "Nein, ohne Chats arbeiten",
  kjuup_io_setup_chats_no_text: "Chats werden ausgeblendet. Aus „Nachrichten“ wird „E-Mail“; Projekte, Aufgaben und Tagesberichte bleiben.",
  kjuup_io_setup_email_title: "Wo möchtest du deine E-Mails lesen?",
  kjuup_io_setup_email_sub: "Hier legst du nur fest, ob du einen E-Mail-Client in Kjuup nutzt oder weiter mit deinem bisherigen Programm arbeitest, zum Beispiel Outlook oder einem anderen. Du kannst später wechseln.",
  kjuup_io_setup_email_client: "E-Mail-Client in Kjuup",
  kjuup_io_setup_email_client_text: "E-Mails direkt in Kjuup lesen und beantworten.",
  kjuup_io_setup_email_reports: "Bisheriger E-Mail-Client",
  kjuup_io_setup_email_reports_text: "E-Mails weiter im aktuellen Programm lesen und beantworten, zum Beispiel Outlook oder einem anderen.",
  kjuup_io_setup_skip: "Später",
  kjuup_io_setup_finish: "Einrichtung abschließen",
  kjuup_io_setup_saved: "Einrichtung gespeichert",
  cockpit_toggle_chats: "Kjuup-Chats",
  cockpit_workspace: "Arbeitsbereich",
  cockpit_toggle_chats_off: "Chats werden unter Nachrichten und in den Projekten ausgeblendet. Aus „Nachrichten“ wird „E-Mail“. Projekte, Aufgaben und Tagesberichte bleiben.",
  cockpit_toggle_chats_info: "Kjuup-Chats in allen Bereichen ein- oder ausblenden. Beim Ausblenden werden die Mitglieder bestehender Chats darüber informiert, dass du über den Kjuup-Chat nicht mehr erreichbar bist.",
  chats_hidden_member_notice: "{name} hat Chats ausgeblendet und ist in Kjuup via Chat nicht mehr erreichbar.",
  chats_hidden_label: "Chats ausgeblendet",
  cockpit_toggle_email: "E-Mail-Client",
  cockpit_toggle_email_off: "Der E-Mail-Client in Kjuup wird ausgeblendet. E-Mails liest und beantwortest du weiter in deinem bisherigen Programm, zum Beispiel Outlook. Tagesberichte bleiben im Cockpit.",
  cockpit_toggle_email_info: "E-Mails direkt in Kjuup lesen und beantworten.",
  cockpit_toggle_teams: "Microsoft Teams",
  cockpit_toggle_teams_info: "Teams-Chats direkt in Kjuup lesen und beantworten.",
  workspace_chats_label: "Chats anzeigen",
  workspace_chats_info: "Wenn deaktiviert, werden Chats in Kjuup.io ausgeblendet. Aus „Nachrichten“ wird „E-Mail“; Projekte, Aufgaben und Tagesberichte bleiben erhalten.",
  workspace_email_mode_label: "E-Mail-Modus",
  workspace_email_mode_client: "E-Mail-Client in Kjuup",
  workspace_email_mode_reports: "Bisheriger E-Mail-Client",
  workspace_email_mode_intro: "Hier legst du nur fest, ob du einen E-Mail-Client in Kjuup nutzt oder weiter mit deinem bisherigen E-Mail-Programm arbeitest, zum Beispiel Outlook oder einem anderen:",
  workspace_email_mode_client_info: "E-Mails direkt in Kjuup lesen und beantworten.",
  workspace_email_mode_reports_info: "E-Mails weiter im aktuellen Programm lesen und beantworten, zum Beispiel Outlook oder einem anderen.",
  // --- Mobile parity: tasks ---
  pro_todo_title: "Aufgaben",
  pro_todo_new_task: "Neue Aufgabe",
  pro_todo_filter: "Filter",
  pro_todo_section_upcoming: "Demnächst",
  pro_todo_section_done: "Erledigt",
  pro_todo_today: "Heute",
  pro_todo_tomorrow: "Morgen",
  pro_todo_yesterday: "Gestern",
  pro_todo_since_yesterday: "Seit gestern",
  pro_todo_prev_week: "Vorherige Woche",
  pro_todo_next_week: "Nächste Woche",
  pro_todo_pick_date: "Datum wählen",
  pro_todo_pick_date_chip: "Datum wählen",
  pro_todo_show_day: "Tag anzeigen",
  pro_todo_showing: "Anzeige: {{day}}",
  pro_todo_of_completed: "{{done}} von {{total}} abgeschlossen",
  pro_todo_selected: "{{n}} ausgewählt",
  pro_todo_adjust_done: "Fertig",
  pro_todo_bulk_delete_title: "{{n}} Aufgaben löschen?",
  pro_todo_delete_title: "Aufgabe löschen",
  pro_todo_deleting: "Wird gelöscht...",
  pro_todo_empty_title: "Nichts zu tun",
  pro_todo_empty_hint: "Keine Aufgaben in dieser Ansicht.",
  pro_todo_room_empty: "Keine Aufgaben in diesem Projekt",
  pro_todo_done_confirm: "Möchtest du diese Aufgabe wirklich als erledigt markieren?",
  pro_todo_mark_open: "Als offen markieren",
  pro_todo_task: "Aufgabe",
  pro_todo_more: "Mehr",
  pro_todo_due: "Fällig",
  pro_todo_due_at: "Fällig {{when}}",
  pro_todo_created_by: "Erstellt von",
  pro_todo_chat: "Chat",
  pro_todo_description: "Beschreibung",
  pro_todo_assignees: "Zuständige",
  pro_todo_add_people: "Personen hinzufügen",
  pro_todo_search_people: "Personen suchen",
  pro_todo_assigned: "(zugewiesen)",
  pro_todo_status_open: "Offen",
  pro_todo_status_done: "Erledigt",
  pro_todo_bookmarked_tag: "Vorgemerkte Aufgabe",
  pro_todo_activity: "Aktivität",
  pro_todo_show_all: "Alle anzeigen ({{n}})",
  pro_todo_show_less: "Weniger anzeigen",
  pro_todo_reopen: "Aufgabe wieder öffnen",
  pro_todo_mark_in_progress: "Als in Bearbeitung markieren",
  pro_todo_mark_not_started: "Als nicht begonnen markieren",
  pro_todo_open_room: "Projekt öffnen",
  pro_todo_go_to_message: "Zur Nachricht",
  pro_todo_go_to_email: "Zur E-Mail",
  pro_todo_edit_title: "Aufgabe bearbeiten",
  pro_todo_room: "Projekt",
  pro_todo_what: "Was ist zu tun?",
  pro_todo_select_room: "Projekt auswählen",
  pro_todo_no_room: "Kein Projekt",
  pro_todo_assign_to: "Zuweisen an",
  pro_todo_select_people: "Personen auswählen",
  pro_todo_create_task: "Aufgabe erstellen",
  pro_todo_created: "Aufgabe erstellt",
  pro_todo_enter_note: "Bitte gib eine Notiz ein",
  pro_todo_search_rooms: "Projekte durchsuchen",
  pro_todo_no_rooms: "Keine Projekte gefunden",
  pro_todo_no_rooms_match: "Keine Projekte für „{{q}}“",
  pro_todo_no_people: "Keine Personen gefunden",
  pro_todo_no_people_match: "Keine Personen für „{{q}}“",
  pro_todo_apply: "Übernehmen",
  pro_todo_clear: "Zurücksetzen",
  pro_todo_filter_clear_n: "Zurücksetzen ({{n}})",
  pro_todo_filter_done: "{{p}} % erledigt",
  pro_todo_one_task: "1 Aufgabe",
  pro_todo_n_tasks: "{{n}} Aufgaben",
  todo_apply_filters: "Anwenden",
  select_user_back_to_in_progress: "Benutzer auswählen, der zurück in Bearbeitung gesetzt wird",
  unassign_task_confirm: "Möchtest du dich von dieser Aufgabe abmelden?",
  v2_todo_remove: "Entfernen",
  // --- Mobile parity: chat ---
  chat_search_running: "Suche läuft …",
  chat_search_press_enter: "Enter ↵ zum Suchen",
  chat_search_loading_hit: "Lade Treffer {n} …",
  chat_search_no_results: "Keine Treffer",
  chat_search_loading_to_hit: "Nachrichten bis zum Treffer werden geladen …",
  chat_copied_many: "{n} Nachrichten kopiert",
  chat_copied_one: "Nachricht kopiert",
  chat_delete_messages_confirm: "Möchtest du diese Nachrichten wirklich löschen?",
  chat_image_copied: "Bild kopiert",
  chat_info_delivered: "Zugestellt",
  chat_info_pending: "Noch nicht zugestellt.",
  chat_info_read: "Gelesen",
  chat_menu_bookmark: "Vormerken",
  chat_menu_bookmark_remove: "Vormerkung entfernen",
  chat_menu_edit: "Bearbeiten",
  chat_menu_save: "Speichern",
  chat_menu_select: "Auswählen",
  chat_mic_unavailable: "Kein Mikrofon gefunden.",
  chat_save_failed: "Die Datei konnte nicht gespeichert werden.",
  chat_select_to_forward: "Wähle die Nachrichten aus, die du weiterleiten möchtest.",
  chat_attach: "Anhängen",
  chat_edit_message: "Nachricht bearbeiten",
  chat_emoji: "Emoji einfügen",
  chat_format_bold: "Fett",
  chat_format_bullets: "Aufzählung",
  chat_format_italic: "Kursiv",
  chat_format_numbers: "Nummerierte Liste",
  chat_format_underline: "Unterstrichen",
  chat_is_typing: "schreibt",
  chat_loading_newer: "Neuere Nachrichten werden geladen …",
  chat_loading_older: "Ältere Nachrichten werden geladen …",
  chat_members: "Mitglieder",
  chat_message_placeholder: "Nachricht",
  chat_more_reactions: "Weitere Reaktionen",
  chat_online: "online",
  chat_open_info: "Chat-Info öffnen",
  chat_original: "Original",
  chat_photo: "Foto",
  chat_poll: "Umfrage",
  chat_reactions_who: "Rechtsklick: wer hat reagiert",
  chat_record_voice: "Sprachnachricht aufnehmen",
  chat_recording_delete: "Aufnahme löschen",
  chat_reply_to: "Antwort an",
  chat_retry_send: "Erneut senden",
  chat_save_edit: "Speichern",
  chat_scroll_latest: "Zur neuesten Nachricht",
  chat_search_clear: "Leeren",
  chat_search_close: "Suche schließen",
  chat_search_in_chat: "Im Chat suchen",
  chat_search_next: "Nächster Treffer",
  chat_search_placeholder: "In diesem Chat suchen",
  chat_search_prev: "Vorheriger Treffer",
  chat_select_message: "Nachricht auswählen",
  chat_selected: "ausgewählt",
  chat_send: "Senden",
  chat_send_voice: "Sprachnachricht senden",
  chat_show_original: "Original anzeigen",
  chat_show_translation: "Übersetzung anzeigen",
  chat_status_pending: "Wird gesendet …",
  chat_status_sent: "Gesendet",
  chat_translated: "Übersetzt",
  chat_translated_from: "Übersetzt aus",
  chat_translating: "Wird übersetzt …",
  chat_typing: "schreibt",
  chat_unread_many: "ungelesene Nachrichten",
  chat_unread_one: "ungelesene Nachricht",
  chat_yourself: "dich selbst",
  chat_info_title_contact: "Kontaktinfo",
  chat_info_title_chat: "Chat-Info",
  chat_info_title_room: "Projekt-Chat-Info",
  chat_info_title_group: "Gruppen-Info",
  chat_info_online: "Online",
  chat_info_mute: "Stumm",
  chat_info_unmute: "Ton an",
  chat_info_media: "Dateien",
  chat_info_export: "Export",
  chat_info_members: "Mitglieder",
  chat_info_member_one: "1 Mitglied",
  chat_info_members_count: "{n} Mitglieder",
  chat_info_kind_room: "Projekt",
  chat_info_kind_group: "Gruppe",
  chat_info_external: "Extern",
  chat_info_send_message: "Nachricht senden",
  chat_info_description: "Beschreibung",
  chat_info_add: "Hinzufügen",
  chat_info_no_members: "Keine Mitglieder gefunden",
  chat_info_leave_group: "Chat Gruppe verlassen",
  chat_info_leave_confirm: "Willst du die Chat-Gruppe wirklich verlassen?",
  chat_share_title: "Teilen",
  chat_share_gallery: "Galerie",
  chat_share_meeting_point: "Treffpunkt",
  chat_share_task: "Aufgabe",
  chat_location_search: "Adresse suchen",
  chat_location_accuracy_50: "Bis zu 50 m genau",
  chat_location_accuracy_10: "Bis zu 10 m genau",
  chat_location_send_meeting: "Treffpunkt senden",
  chat_location_getting: "Standort wird ermittelt …",
  chat_location_unavailable: "Standort nicht verfügbar. Suche eine Adresse.",
  chat_location_tap_map: "Tippe auf die Karte, um den Treffpunkt zu setzen.",
  chat_location_drag_hint: "Ziehe den Pin, um den Treffpunkt anzupassen.",
  chat_location_my_location: "Mein Standort",
  chat_voice_play: "Sprachnachricht abspielen",
  chat_voice_pause: "Pause",
  chat_voice_speed: "Geschwindigkeit",
  chat_voice_ai_transcript: "KI-Transkript",
  chat_voice_transcribing: "Transkription läuft…",
  chat_doc_download: "Herunterladen",
  chat_doc_retry: "Erneut versuchen",
  chat_poll_you_voted: "Du hast abgestimmt",
  chat_forward_to_one: "Weiterleiten an 1 Chat",
  chat_forward_to_n: "Weiterleiten an {n} Chats",
  chat_forward_select: "Chats auswählen",
  // --- Mobile parity: chat list ---
  reply_sending_photo: "Foto wird gesendet…",
  reply_sending_photos: "Fotos werden gesendet… {0}/{1}",
  reply_media_sent: "Gesendet",
  kjuup_messages_title: "Nachrichten",
  pro_messages_unread: "Ungelesen",
  pro_messages_rooms: "Projekte",
  pro_messages_groups: "Gruppen",
  pro_messages_direct: "Direkt",
  pro_messages_no_chats_filter: "Keine Chats in diesem Filter",
  pro_messages_row_more: "Weitere Optionen",
  pro_messages_remove_bookmark: "Nicht mehr merken",
  mark_as_task: "Als Aufgabe markieren",
  unmark_task: "Aus Aufgaben entfernen",
  pinned_room_pin: "Projekt anheften",
  pinned_room_unpin_room: "Projekt lösen",
  pro_messages_typing: "schreibt…",
  v2_chat_is_typing: "schreibt",
  pro_messages_tag_mail: "Mail",
  pro_messages_selected: "{n} ausgewählt",
  date_format_short: "DD.MM.YY",
  chat_list_audio_duration: "Dauer",
  chat_muted: "Stummgeschaltet",
  // --- Mobile parity: personal settings ---
  pro_settings_on: "An",
  pro_settings_off: "Aus",
  pro_settings_all: "Alle",
  pro_settings_profile: "Profil",
  pro_settings_security: "Sicherheit & Anmeldung in zwei Schritten",
  pro_settings_unavailability: "Abwesenheit",
  pro_settings_company: "Firma",
  pro_settings_my_companies: "Meine Firmen",
  pro_settings_admin_center: "Admin-Center",
  pro_settings_app: "App",
  pro_settings_logout: "Abmelden",
  pro_settings_delete_profile: "Profil löschen",
  pro_settings_search: "Einstellungen durchsuchen",
  pro_settings_search_empty: "Keine Einstellungen zu „{{q}}“",
  pro_settings_no_results: "Keine Ergebnisse",
  pro_settings_plan_title: "Paket {{pkg}}",
  pro_settings_plan_sub: "Pakete vergleichen und Plätze verwalten",
  pro_settings_plan_sub_static: "Dein aktuelles Paket",
  pro_settings_made_in: "Made in Germany",
  pro_settings_unavail_period: "Zeitraum",
  pro_settings_email: "E-Mail",
  pro_settings_phone: "Telefon",
  pro_settings_choose: "Auswählen",
  pro_settings_save: "Speichern",
  pro_settings_push: "Push",
  pro_settings_quiet_hours: "Ruhezeiten",
  pro_settings_notification_hours: "Benachrichtigungszeiten",
  pro_settings_quiet_from: "Von",
  pro_settings_quiet_until: "Bis",
  pro_settings_quiet_all_day: "Ganztägig Ruhe",
  pro_settings_push_allowed_browser: "Push-Benachrichtigungen sind in diesem Browser erlaubt",
  pro_settings_push_off_browser: "Push-Benachrichtigungen sind in diesem Browser ausgeschaltet",
  pro_settings_push_allow_browser: "Benachrichtigungen erlauben",
  pro_settings_cal_connect: "Kalender verbinden",
  pro_settings_cal_google: "Google Kalender",
  pro_settings_cal_outlook: "Outlook Kalender",
  pro_settings_cal_apple: "Apple / CalDAV",
  pro_settings_profile_role_required: "Bitte wähle deine Branche aus.",
  pro_settings_profile_first_name_required: "Bitte gib deinen Vornamen ein.",
  pro_settings_profile_last_name_required: "Bitte gib deinen Nachnamen ein.",
  v2_settings_account: "Konto",
  v2_settings_workspace: "Kjuup.io-Arbeitsbereich",
  v2_settings_delete_title: "Profil löschen?",
  v2_settings_connected: "Verbunden",
  v2_notif_weekdays: "Werktags",
  v2_auth_twofa_off_confirm: "Zwei-Faktor-Authentifizierung ausschalten?",
  v2_profile_edit_title: "Profil bearbeiten",
  v2_profile_edit_photo: "Foto bearbeiten",
  recommend_kjuup: "Kjuup weiterempfehlen",
  confirm_logout: "Zum Abmelden bestätigen",
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Aufgaben bleiben in deinem Todoist-Projekt „Kjuup“ in beide Richtungen synchron. Eine Aufgabe, die du dort anlegst, wird eine persönliche Kjuup-Aufgabe.",
  todoist_connect: "Todoist verbinden",
  todoist_connected: "Todoist verbunden",
  todoist_connect_failed: "Todoist-Verbindung fehlgeschlagen",
  todoist_disconnect: "Trennen",
  todoist_disconnected: "Todoist getrennt",
  todoist_disconnect_confirm: "Todoist trennen? Bereits angelegte Aufgaben bleiben in Todoist. Die Synchronisierung stoppt.",
  todoist_sync_now: "Jetzt synchronisieren",
  todoist_syncing: "Wird synchronisiert…",
  todoist_sync_done: "Synchronisierung abgeschlossen",
  todoist_sync_failed: "Synchronisierung fehlgeschlagen",
  todoist_auth_error: "Verbinde Todoist erneut, um weiter zu synchronisieren.",
  todoist_last_sync: "Letzte Synchronisierung",
  todoist_not_connected: "Todoist ist nicht verbunden",
  todoist_auth_url_failed: "Die Todoist-Autorisierung konnte nicht geöffnet werden.",
  // --- Mobile parity: plans ---
  pro_settings_plans: "Pakete",
  pro_settings_plan_current: "Aktuell",
  pro_settings_plan_switch: "Zu {{pkg}} wechseln",
  pro_settings_plan_kjuup_tag: "Chat, Projekte und Aufgaben",
  pro_settings_plan_kjuup_f1: "Projekte und Chats",
  pro_settings_plan_kjuup_f2_priorities: "Aufgaben inkl. vorgemerkter Aufgaben",
  pro_settings_plan_plus_tag: "Für wachsende Firmen",
  pro_settings_plan_plus_f1: "Alles aus Kjuup",
  pro_settings_plan_plus_f2: "Firmenbeiträge und interne News",
  pro_settings_plan_plus_f3: "Firmendokumente",
  pro_settings_plan_plus_f4: "Admin-Center",
  pro_settings_plan_plus_note: "Kjuup+ wird von deiner Firma gebucht.",
  pro_settings_plan_io_tag_v2: "E-Mail, Tagesbericht und Automatisierungen",
  pro_settings_plan_io_admin_body: "Du verwaltest die Kjuup.io-Plätze von {{company}}.",
  pro_settings_plan_manage_seats: "Plätze verwalten",
  pro_settings_plan_per_month: "/ Monat",
  pro_settings_plan_per_year: "/ Jahr",
  // --- Mobile parity: company settings ---
  pro_company_admin_caption_admins: "Verwaltung",
  pro_company_admin_caption_company: "Unternehmen",
  v2_company_no_members: "Noch niemand",
  company_language_none: "Keine Sprache gefunden",
  company_settings_load_error: "Die Firmeneinstellungen konnten nicht geladen werden.",
  company_settings_none: "Für diese Firma gibt es hier keine Einstellungen.",
  company_notification_start_time: "Startzeit",
  company_notification_end_time: "Endzeit",
  admin_center_group_company: "Firma",
  admin_center_group_people: "Personen hinzufügen",
  admin_center_group_settings: "Einstellungen",
  admin_center_articles: "Artikel",
  admin_center_media_export: "Medien-Exportserver",
  admin_center_eyebrow_admin: "Firmenadministrator",
  admin_center_load_error: "Der Admin-Bereich konnte nicht geladen werden.",
  admin_center_admins_only: "Der Admin-Bereich ist nur für Firmenadmins verfügbar.",
  // --- Mobile parity: news ---
  pro_news_post: "Posten",
  pro_news_search_external: "News durchsuchen",
  pro_news_search_internal: "Interne News durchsuchen",
  pro_news_search_in: "{0} durchsuchen",
  pro_news_search_count_one: "1 Beitrag",
  pro_news_search_count_many: "{0} Beiträge",
  pro_news_clear_search: "Suche löschen",
  pro_news_feed_caption: "Artikel",
  pro_news_external: "Extern",
  pro_news_internal: "Intern",
  pro_news_company_showing: "Artikel von {name}",
  pro_news_company_pick: "Firma wählen",
  pro_news_company_search: "Firma suchen",
  pro_news_company_none: "Keine Firma gefunden",
  pro_news_company_new_one: "1 neuer Beitrag",
  pro_news_company_new_n: "{n} neue Beiträge",
  pro_news_company_other_one: "1 neuer Beitrag in einer anderen Firma",
  pro_news_company_other_n: "{n} neue Beiträge in anderen Firmen",
  pro_news_pinned: "Angepinnt",
  pro_news_pin: "Anpinnen",
  pro_news_unpin: "Lösen",
  pro_news_more: "Mehr",
  pro_news_show_likes: "Gefällt-mir-Angaben anzeigen ({0})",
  pro_news_time_now: "jetzt",
  pro_news_time_minutes: "vor {0} Min.",
  pro_news_time_hours: "vor {0} Std.",
  pro_news_read_more: "Weiterlesen",
  pro_news_empty_title: "Kein Artikel gefunden",
  pro_news_empty_search_hint: "Versuch es mit einem anderen Suchbegriff.",
  previous: "Zurück",
  pro_auth_signin_title: 'Willkommen zurück',
  pro_auth_signin_sub: 'Melden Sie sich mit Ihrer geschäftlichen E-Mail-Adresse an.',
  pro_auth_email_or_username: 'E-Mail oder Benutzername',
  pro_auth_email_placeholder: 'name@firma.de',
  pro_auth_forgot_password: 'Passwort vergessen?',
  pro_auth_create_account: 'Konto erstellen',
  pro_auth_show_password: 'Passwort anzeigen',
  pro_auth_hide_password: 'Passwort verbergen',
  pro_auth_register_sub: 'Wir senden Ihnen einen Link, um Ihre E-Mail-Adresse zu bestätigen.',
  pro_auth_register_plus_sub: 'Wählen Sie einen Benutzernamen und ein Passwort. Danach legen Sie Ihre Sicherheits-PIN fest.',
  pro_auth_check_credentials: 'Prüfen Sie Ihre E-Mail-Adresse und Ihr Passwort',
  pro_news_export_pdf: 'Als PDF exportieren',
  pro_news_pdf_failed: 'Das PDF konnte nicht erstellt werden.',
  pro_news_pdf_attachments: 'Anhänge',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link, mit dem Sie Ihr Passwort zurücksetzen können.',
  pro_auth_send_link: 'Link senden',
  pro_auth_plus_reset: 'Mit PIN zurücksetzen',
  pro_auth_show_pin: 'PIN anzeigen',
  pro_auth_hide_pin: 'PIN verbergen',
  v2_auth_plus_only: 'Nur Kjuup+',
  // --- Microsoft Teams (mobile parity: Teams setup) ---
  teams_title: 'Microsoft Teams',
  teams_info: 'Lies und beantworte deine Microsoft-Teams-Chats in Kjuup. Sie erscheinen unter Nachrichten mit dem Hinweis TEAMS.',
  teams_connect: 'Microsoft Teams verbinden',
  teams_connecting: 'Wird verbunden…',
  teams_reconnect: 'Microsoft Teams erneut verbinden',
  teams_connect_again: 'Erneut verbinden',
  teams_disconnect: 'Trennen',
  teams_disconnecting: 'Wird getrennt…',
  teams_sync_now: 'Jetzt synchronisieren',
  teams_syncing: 'Wird synchronisiert…',
  teams_sync_queued: 'Synchronisierung gestartet',
  teams_sync_already: 'Eine Synchronisierung läuft bereits.',
  teams_chip_importing: 'Import läuft',
  teams_chip_not_connected: 'Nicht verbunden',
  teams_chip_reconnect: 'Neu verbinden',
  teams_chip_removing: 'Wird entfernt',
  teams_chip_archived: 'Nur lesen',
  teams_add_account: 'Weiteres Microsoft-Konto verbinden',
  teams_chip_approved: 'Freigegeben',
  teams_status_approved: 'Deine IT hat Kjuup freigegeben',
  teams_approved_body: 'Kjuup ist jetzt für deine Organisation freigegeben. Verbinde dein Microsoft-Konto, um es abzuschließen.',
  teams_consent_granted_toast: 'Deine IT hat Kjuup für Microsoft Teams freigegeben. Verbinde dein Konto unter Einstellungen → Microsoft Teams.',
  teams_account_caption: 'Microsoft-Konto',
  teams_last_sync: 'Letzte Synchronisierung',
  teams_not_available: 'Microsoft Teams ist für dein Konto noch nicht verfügbar.',
  teams_archive_note: 'Deine importierten Teams-Chats bleiben als schreibgeschütztes Archiv unter Nachrichten erhalten.',
  teams_status_removing: 'Deine importierten Teams-Chats werden entfernt…',
  teams_removing_body: 'Sobald dies abgeschlossen ist, kannst du Microsoft Teams erneut verbinden.',
  teams_status_connecting: 'Verbindung wird eingerichtet…',
  teams_progress_hint: 'Aktuelle Chats kommen zuerst, ältere Nachrichten folgen. Du kannst diese Seite verlassen.',
  teams_progress_chats: '{{done}} von {{total}} Chats',
  teams_progress_messages: '{{count}} Nachrichten importiert',
  teams_status_importing: 'Deine Teams-Chats werden importiert…',
  teams_status_importing_history: 'Ältere Nachrichten werden importiert…',
  teams_import_failed_web: 'Nicht alle Chats konnten importiert werden. Klicke auf „Jetzt synchronisieren“, um es erneut zu versuchen.',
  teams_status_consent: 'Freigabe durch deinen IT-Administrator erforderlich',
  teams_consent_body: 'Deine Organisation verlangt, dass ein IT-Administrator Kjuup für Microsoft Teams freigibt. Sende ihm den Freigabelink und verbinde dich danach erneut.',
  teams_consent_copy: 'Link für IT-Administrator kopieren',
  teams_consent_copied: 'Freigabelink kopiert. Sende ihn an deinen IT-Administrator.',
  teams_consent_open: 'Freigabeseite öffnen',
  teams_share_message: 'Bitte gib Kjuup für Microsoft Teams in unserer Organisation frei: {{url}}',
  teams_admin_link_failed: 'Der Freigabelink konnte nicht erstellt werden.',
  teams_status_policy: 'Von deiner Organisation blockiert',
  teams_policy_body: 'Die Richtlinien deiner Organisation erlauben keine Verbindung von Kjuup mit Microsoft Teams. Bitte wende dich an deinen IT-Administrator.',
  teams_status_reconnect: 'Erneute Verbindung erforderlich',
  teams_reconnect_body: 'Kjuup kann nicht mehr auf deine Teams-Chats zugreifen. Sie bleiben schreibgeschützt, bis du die Verbindung erneuerst.',
  teams_connected_toast: 'Microsoft Teams ist verbunden. Deine Chats werden importiert.',
  teams_disconnected: 'Microsoft Teams getrennt',
  teams_disconnect_title: 'Microsoft Teams trennen?',
  teams_disconnect_body: 'Kjuup beendet die Synchronisierung mit Teams. Deine Chats in Microsoft Teams bleiben unverändert. Was soll mit den importierten Chats in Kjuup geschehen?',
  teams_disconnect_delete: 'Importierte Chats löschen',
  teams_disconnect_keep: 'Schreibgeschützt behalten',
  teams_err_wrong_user: 'Diese Anmeldung wurde von einem anderen Kjuup-Benutzer gestartet. Bitte verbinde dich erneut.',
  teams_err_expired: 'Die Anmeldung ist abgelaufen. Bitte verbinde dich erneut.',
  teams_err_not_entitled: 'Microsoft Teams ist Teil von Kjuup.io. Aktiviere Kjuup.io, um die Verbindung herzustellen.',
  teams_err_consent_required: 'Dein IT-Administrator muss Kjuup zuerst für Microsoft Teams freigeben.',
  teams_err_policy_blocked: 'Die Richtlinien deiner Organisation erlauben keine Verbindung von Kjuup mit Microsoft Teams.',
  teams_err_personal_account: 'Private Microsoft-Konten werden nicht unterstützt. Melde dich mit deinem Geschäfts- oder Schulkonto an.',
  teams_err_cancelled: 'Die Microsoft-Anmeldung wurde abgebrochen.',
  teams_err_already_linked: 'Dieses Microsoft-Konto ist bereits mit einem anderen Kjuup-Benutzer verbunden.',
  teams_err_different_account: 'Es ist bereits ein anderes Microsoft-Konto verbunden. Trenne es zuerst.',
  teams_err_disconnect_in_progress: 'Deine importierten Teams-Chats werden noch entfernt. Bitte versuche es in einigen Minuten erneut.',
  teams_err_unavailable: 'Microsoft Teams ist vorübergehend nicht erreichbar. Bitte versuche es später erneut.',
  teams_err_too_soon: 'Vor wenigen Minuten wurde bereits eine Synchronisierung gestartet. Bitte versuche es später erneut.',
  teams_err_generic: 'Microsoft Teams konnte nicht verbunden werden. Bitte versuche es erneut.',
  teams_err_disconnect: 'Microsoft Teams konnte nicht getrennt werden. Bitte versuche es erneut.',
  teams_delete_archive_body: 'Deine importierten Teams-Chats werden endgültig aus Kjuup entfernt. Deine Chats in Microsoft Teams bleiben unverändert.',
  pro_messages_tag_teams: 'Teams',
  teams_open_in_teams: 'In Teams öffnen',
  teams_read_only_reconnect: 'Verbinde Microsoft Teams in den Einstellungen erneut, um Nachrichten zu senden.',
  teams_read_only_left: 'Du bist kein Mitglied dieses Microsoft-Teams-Chats mehr.',
  teams_read_only: 'Dieser Microsoft-Teams-Chat ist schreibgeschützt.',
  teams_reconnect_action: 'Erneut verbinden',
  teams_retry_failed: 'Die Nachricht konnte nicht erneut gesendet werden.',
  teams_file_unavailable: 'Diese Datei ist nur in Microsoft Teams verfügbar.',
  teams_call_audio_title: 'Teams-Anruf',
  teams_call_video_title: 'Teams-Videoanruf',
  teams_call_meeting_title: 'Teams-Besprechung',
  teams_call_join: 'Jetzt beitreten',
  teams_call_join_hint: 'Teams-App oder Browser',
  teams_call_confirm_audio: 'Teams-Anruf starten?',
  teams_call_confirm_video: 'Teams-Videoanruf starten?',
  teams_call_confirm_body: 'Kjuup sendet einen Link zum Beitreten in diesen Chat. Alle im Chat können über die Teams-App oder den Browser beitreten.',
  teams_call_confirm_ok: 'Link senden & beitreten',
  teams_call_opening: 'Teams wird geöffnet…',
  teams_call_failed: 'Der Teams-Anruf konnte nicht gestartet werden.',
  teams_call_consent_title: 'Teams-Anrufe erlauben',
  teams_call_consent_body: 'Für Anrufe braucht Kjuup einmalig deine Erlaubnis bei Microsoft, Besprechungen zu erstellen.',
  teams_call_consent_ok: 'Erlauben',
  teams_call_consent_done: 'Teams-Anrufe sind erlaubt.',
  teams_user_fallback: 'Teams-Benutzer',
  teams_members: 'Mitglieder',
  teams_managed_in_teams: 'Mitglieder, Name und das Verlassen des Chats werden in Microsoft Teams verwaltet.',
  teams_send_failed: 'Nicht an Teams gesendet',
  teams_sending: 'Wird an Teams gesendet…',
  teams_room_label: 'Projekt',
  teams_room_none: 'Keine Zuordnung',
  teams_room_assign: 'Projekt zuordnen',
  teams_room_change: 'Projekt ändern',
  teams_room_remove: 'Zuordnung entfernen',
  teams_room_title: 'Teams-Chat einem Projekt zuordnen',
  teams_room_hint: 'Nachrichten aus diesem Teams-Chat erscheinen dann im Tagesbericht unter dem Projekt, auch im Tagesbericht des Projekts. Die Projektmitglieder sehen den Chat nicht.',
  teams_room_placeholder: 'Projekt suchen',
  teams_room_save: 'Zuordnen',
  teams_room_assigned: 'Teams-Chat dem Projekt zugeordnet.',
  teams_room_removed: 'Projektzuordnung entfernt.',
  teams_room_not_assignable: 'Dieses Projekt ist nicht verfügbar. Es ist abgeschlossen oder du bist kein Mitglied mehr.',
  teams_room_no_rooms: 'Du bist noch in keinem Projekt.',
  teams_room_pick_existing: 'Bitte wähle ein vorhandenes Projekt aus der Liste.',
  teams_sender_you: 'Du',
  pro_todo_project_required: "Bitte wähle ein Projekt aus",
  pro_todo_choose_project: "Für welches Projekt ist die Aufgabe?",
  today_label: "heute",
  tomorrow_label: "morgen",
  cockpit_todo_overdue: "überfällig",
  cockpit_report_management_fazit: "Management-Fazit",
  unknown: "–",
  cockpit_todo_appointment: "Termin",
  cockpit_todo_deadline: "Frist",
  cockpit_todo_deadline_define: "Frist definieren",
  pro_todo_status_acknowledged: "Bestätigt",
  pro_todo_responsible: "Verantwortlich",
  pro_todo_notice_confirmed: "Im Chat bestätigt",
  pro_todo_notice_sent_at: "Nachricht gesendet",
  pro_todo_notice_again: "Nachricht erneut senden",
  pro_todo_notice_send: "Per Kjuup-Nachricht informieren",
  pro_todo_add_assignee: "Hinzufügen",
  pro_todo_edit: "Bearbeiten",
  pro_todo_change_room: "Projekt ändern",
  pro_todo_due_on: "Fällig am",
  pro_todo_edit_due: "Fälligkeit bearbeiten",
  pro_todo_no_date: "Ohne Datum",
  pro_todo_edit_description: "Beschreibung bearbeiten",
  pro_todo_no_description: "Noch keine Beschreibung",
  pro_todo_title_label: "Titel",
  pro_todo_title_placeholder: "Titel eingeben...",
  pro_todo_source_email: "E-Mail",
  pro_todo_sources: "Quellen",
  cockpit_email_accounts_n_many: "{{n}} Konten verbunden",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup-Kontakte",
  combined_tab_teams: "Teams-Kontakte",
  combined_bridge_failed: "Die Teams-Kopie konnte nicht erstellt werden.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup- und Teams-Kontakte: Es wird eine neue Gruppe erstellt, die auch in Microsoft Teams erscheint.",
  teams_new_chat_title: "Neuer Teams-Chat",
  teams_new_chat_topic: "Gruppenname (optional)",
  teams_new_chat_start: "Chat starten",
  teams_new_chat_creating: "Chat wird erstellt…",
  teams_new_chat_forbidden: "Microsoft Teams erlaubt diesen Chat nicht (z. B. eine Person außerhalb deiner Organisation oder eine Richtlinie deiner IT).",
  teams_new_chat_too_many: "Zu viele Personen für einen Chat.",
  teams_new_chat_type_hint: "Tippe einen Namen, um in deiner Organisation zu suchen.",
  teams_new_chat_directory_forbidden: "Deine Organisation erlaubt die Suche im Verzeichnis nicht. Es werden nur Personen aus deinen Teams-Chats gezeigt.",
  teams_new_chat_account: "Konto",
};
